export const Logo = (props) => {
  return (
    <svg
      width="42"
      height="32"
      viewBox="0 0 42 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7215_70224)">
        <path
          d="M13.2216 4.92228C13.2216 5.10116 13.1352 5.20092 12.9611 5.22156C12.937 5.225 9.53842 5.22614 9.51173 5.22614C9.48377 5.22614 9.30837 5.24564 8.98428 5.28233C8.66019 5.32132 8.31576 5.42222 7.95099 5.58734C7.58623 5.75246 7.24816 6.01849 6.93931 6.38657C6.63047 6.75465 6.47541 7.28097 6.47541 7.96553V14.7366H12.8798C13.1047 14.7366 13.2178 14.826 13.2178 15.0026C13.2178 15.2067 13.1047 15.3076 12.8798 15.3076H6.47541V26.6023C6.47541 26.8064 6.37755 26.9073 6.18055 26.9073C5.95559 26.9073 5.84375 26.8064 5.84375 26.6023V7.96667C5.84375 7.15483 6.03312 6.52761 6.41187 6.08385C6.79188 5.64009 7.20749 5.311 7.65613 5.09428C8.10605 4.8787 8.72628 4.73308 9.51173 4.65625C9.53842 4.65625 12.9357 4.65625 12.9586 4.65969C13.1352 4.67804 13.2229 4.76633 13.2229 4.92228H13.2216Z"
          fill="white"
        />
        <path
          d="M6.17698 27.5686C5.54785 27.5686 5.10938 27.1718 5.10938 26.6054V7.96861C5.10938 7.01229 5.35086 6.24402 5.82874 5.68331C6.27103 5.16731 6.76797 4.774 7.30813 4.51485C7.84828 4.25685 8.54223 4.08944 9.42935 4.00344L9.50688 4C12.9677 4 12.9918 4.00229 13.044 4.00917C13.5803 4.06421 13.9476 4.43229 13.9476 4.92536C13.9476 5.41843 13.5892 5.81173 13.0554 5.87824C13.002 5.88512 12.969 5.88856 9.5323 5.88856C9.46748 5.89429 9.31497 5.91149 9.07349 5.94016C8.83328 5.96882 8.56383 6.05024 8.27278 6.18096C8.01097 6.29906 7.75551 6.50432 7.51529 6.78869C7.30686 7.03752 7.2001 7.43426 7.2001 7.96861V14.0803H12.8749C13.504 14.0803 13.9425 14.461 13.9425 15.0057C13.9425 15.5504 13.5028 15.9689 12.8749 15.9689H7.2001V26.6042C7.2001 27.1718 6.77814 27.5674 6.17571 27.5674L6.17698 27.5686Z"
          fill="white"
        />
        <path
          d="M34.9864 4.6875C35.2114 4.6875 35.3245 4.77694 35.3245 4.95467V12.0296C35.2686 12.4607 35.1694 12.8667 35.0296 13.2474C34.8885 13.5776 34.6776 13.9136 34.3967 14.2553C34.1158 14.5981 33.7218 14.871 33.2172 15.0729C33.7231 15.2758 34.1997 15.6061 34.6509 16.0624C35.1008 16.5188 35.3258 17.1919 35.3258 18.0794V26.6347C35.3258 26.8376 35.2126 26.9385 34.9877 26.9385C34.7627 26.9385 34.6509 26.8376 34.6509 26.6347V18.0794C34.6509 17.3948 34.4958 16.8685 34.187 16.5004C33.8781 16.1335 33.5401 15.8663 33.1753 15.7012C32.8093 15.5361 32.4648 15.4352 32.142 15.3974C31.8192 15.3595 31.6425 15.34 31.6146 15.34H28.5782V26.6358C28.5782 26.8388 28.4791 26.9397 28.2821 26.9397C28.0572 26.9397 27.9453 26.8388 27.9453 26.6358V4.95467C27.9453 4.77694 28.0572 4.6875 28.2821 4.6875C28.4791 4.6875 28.5782 4.77694 28.5782 4.95467V14.7701H31.6146C32.3733 14.7701 32.9567 14.6314 33.3647 14.3516C33.7714 14.073 34.0675 13.7679 34.2505 13.4377C34.4335 13.1086 34.5454 12.7979 34.5886 12.5055C34.6305 12.2142 34.6509 12.0548 34.6509 12.0296V4.95467C34.6509 4.77694 34.764 4.6875 34.9877 4.6875H34.9864Z"
          fill="white"
        />
        <path
          d="M34.9854 27.5998C34.3562 27.5998 33.9178 27.2042 33.9178 26.6378V18.0825C33.9178 17.5481 33.811 17.1514 33.6013 16.9003C33.3624 16.6171 33.1082 16.4118 32.8438 16.2925C32.554 16.1618 32.2833 16.0804 32.0431 16.0529C31.8029 16.0242 31.6491 16.007 31.583 16.0013H29.3042V26.6378C29.3042 27.2042 28.8822 27.5998 28.2785 27.5998C27.6748 27.5998 27.2109 27.2042 27.2109 26.6378V4.95661C27.2109 4.41194 27.6494 4.03125 28.2785 4.03125C28.9077 4.03125 29.3042 4.41194 29.3042 4.95661V14.1127H31.6097C32.202 14.1127 32.643 14.0176 32.9175 13.8284C33.234 13.6116 33.4602 13.3812 33.5924 13.1449C33.7373 12.8847 33.8275 12.6416 33.8593 12.4214C33.8898 12.2058 33.9089 12.0671 33.9152 12.0086V4.95661C33.9152 4.41194 34.3537 4.03125 34.9828 4.03125C35.612 4.03125 36.0504 4.41194 36.0504 4.95661L36.0453 12.1084C35.9843 12.5796 35.8738 13.0326 35.7174 13.4568C35.5408 13.8719 35.2955 14.2629 34.9777 14.6505C34.8545 14.8019 34.7134 14.9418 34.5558 15.0713C34.7744 15.2353 34.9854 15.4199 35.1887 15.6275C35.7594 16.2065 36.0492 17.0333 36.0492 18.0825V26.6378C36.0492 27.2042 35.6094 27.5998 34.9816 27.5998H34.9854Z"
          fill="white"
        />
        <path
          d="M23.8059 13.6757C23.947 13.397 24.0537 13.1367 24.1236 12.8959C24.1923 12.6551 24.2418 12.3696 24.2711 12.0394V8.0077C24.1872 7.29791 24.0245 6.73375 23.7856 6.31407C23.5479 5.89554 23.1755 5.51485 22.6684 5.17199C22.2197 4.86927 21.6097 4.70874 20.856 4.6732C20.8179 4.66861 20.7886 4.66173 20.7492 4.65829C20.7162 4.65829 17.2109 4.6537 17.1855 4.65829C16.9885 4.70989 16.8906 4.8108 16.8906 4.9633V26.641C16.8906 26.7935 16.9885 26.8956 17.1855 26.946C17.2084 26.9495 20.7454 26.946 20.7492 26.946C20.8052 26.9414 20.8522 26.9311 20.9018 26.9242C21.8334 26.8669 22.5972 26.5917 23.1742 26.0723C23.4538 25.8189 23.6648 25.5528 23.8046 25.273C23.9457 24.9944 24.0525 24.7341 24.1224 24.4933C24.191 24.2525 24.2406 23.967 24.2698 23.6368V18.088C24.2698 17.2005 24.0436 16.5274 23.5936 16.0711C23.145 15.6147 22.6671 15.2856 22.1613 15.0815C22.554 14.929 22.8921 14.7272 23.1742 14.4726C23.4538 14.2192 23.6648 13.9532 23.8046 13.6734L23.8059 13.6757ZM23.131 16.5102C23.4399 16.8783 23.5949 17.4046 23.5949 18.0892V23.6379C23.5949 23.8661 23.553 24.108 23.4691 24.3614C23.4132 24.5656 23.328 24.78 23.2149 25.0082C23.1031 25.2364 22.934 25.4531 22.7091 25.6549C22.1753 26.1365 21.4584 26.3773 20.5599 26.3773C20.5573 26.3773 18.1184 26.336 17.5248 26.3314V15.3487H20.5599C20.5866 15.3487 20.7632 15.3681 21.0873 15.406C21.4101 15.4438 21.7546 15.5459 22.1193 15.7099C22.4854 15.875 22.8234 16.141 23.1323 16.5091L23.131 16.5102ZM20.5586 14.7409H17.5236V5.27405C18.0993 5.26831 19.4669 5.2729 20.2065 5.2729C20.2065 5.27749 20.5916 5.2729 20.631 5.2729C21.3529 5.28207 21.9147 5.41853 22.31 5.68799C22.7167 5.96663 23.0115 6.27165 23.1946 6.60189C23.3763 6.93098 23.4894 7.24173 23.5326 7.53413C23.5746 7.82538 23.5949 7.98477 23.5949 8.00999V12.0417C23.5949 12.2699 23.553 12.5118 23.4691 12.7652C23.4132 12.9682 23.328 13.1837 23.2149 13.4119C23.1031 13.6401 22.934 13.8557 22.7091 14.0587C22.2032 14.515 21.4877 14.7432 20.5599 14.7432L20.5586 14.7409Z"
          fill="white"
        />
        <path
          d="M18.2052 27.6073C17.1325 27.6073 17.1122 27.6038 17.0537 27.5935L16.9876 27.5798C16.4793 27.449 16.1641 27.089 16.1641 26.6418V4.96407C16.1641 4.51802 16.4793 4.15797 16.9864 4.0261L17.0347 4.01578C17.1016 4.00278 18.3171 3.99782 20.681 4.00087L20.8323 4.00546C20.8717 4.0089 20.906 4.01463 20.9403 4.02037C21.8325 4.06738 22.5621 4.27837 23.1086 4.64645C23.7034 5.04893 24.1495 5.50874 24.438 6.01442C24.7214 6.51207 24.9057 7.14159 24.9997 7.93852L25.0036 8.00847L25.001 12.0929C24.968 12.4598 24.9121 12.7855 24.832 13.0618C24.7519 13.337 24.635 13.626 24.4736 13.9482C24.2982 14.2968 24.0364 14.6305 23.6957 14.9401C23.6398 14.9905 23.5814 15.0398 23.5216 15.0868C23.7364 15.2485 23.9436 15.432 24.1444 15.6349C24.7151 16.214 25.0048 17.0408 25.0048 18.09L25.0023 23.6914C24.9692 24.0584 24.9133 24.384 24.8333 24.6604C24.7532 24.9367 24.6363 25.2268 24.4736 25.5479C24.2995 25.8953 24.0376 26.229 23.6957 26.5386C23.0094 27.1566 22.1007 27.5052 20.9924 27.5809C20.9225 27.5924 20.8768 27.5981 20.8259 27.6027L20.7535 27.6061C19.5473 27.6073 18.7441 27.6084 18.2065 27.6084L18.2052 27.6073ZM18.2573 25.6797C19.6643 25.6912 20.2705 25.7027 20.5628 25.7233V25.7199C21.267 25.7199 21.802 25.5467 22.196 25.1901C22.3574 25.0445 22.4769 24.8943 22.5506 24.7429C22.6472 24.5491 22.7184 24.368 22.7641 24.2017C22.8366 23.9827 22.8684 23.8038 22.8684 23.6387V18.09C22.8684 17.5545 22.7629 17.1577 22.5532 16.9089C22.3142 16.6245 22.06 16.4204 21.7957 16.3012C21.5059 16.1704 21.2364 16.089 20.9962 16.0615C20.756 16.0328 20.6022 16.0156 20.5362 16.0099H18.2586V25.6809L18.2573 25.6797ZM18.2573 14.0824H20.5628C21.2949 14.0824 21.8287 13.9207 22.196 13.5904C22.3574 13.4448 22.4769 13.2946 22.5506 13.1444C22.6472 12.9495 22.7184 12.7694 22.7641 12.6032C22.8366 12.3853 22.8684 12.2053 22.8684 12.0401V8.0314C22.862 7.97292 22.8429 7.83418 22.8124 7.61631C22.7807 7.40188 22.6904 7.15879 22.5455 6.89506C22.4134 6.65884 22.1871 6.42837 21.8719 6.21165C21.6101 6.03277 21.1907 5.93874 20.6264 5.93186C20.4548 5.93301 20.3214 5.93415 20.2121 5.93071V5.93301H19.4774C19.0771 5.93301 18.6399 5.93071 18.2599 5.93186V14.0847L18.2573 14.0824Z"
          fill="white"
        />
        <path
          d="M4.50626 31.6684C4.08048 31.6684 3.80469 31.4196 3.80469 31.0343C3.80469 30.672 4.08048 30.4392 4.50626 30.4392H37.607C38.2806 30.4392 38.7954 30.3211 39.1373 30.0872C39.4969 29.8407 39.7588 29.5723 39.9164 29.2891C40.079 28.9956 40.1807 28.7169 40.2176 28.4612C40.2544 28.2055 40.2748 28.0564 40.2786 28.0152C40.2786 27.998 40.2786 24.9341 40.2837 24.8871C40.3345 24.5499 40.6014 24.3516 40.9801 24.3516C41.3589 24.3516 41.5915 24.5545 41.6347 24.8813C41.6372 24.8985 41.641 24.9237 41.641 28.0289L41.6385 28.0645C41.5495 28.8132 41.3729 29.4175 41.1136 29.8579C40.8518 30.3028 40.4489 30.7156 39.9176 31.0859C39.3622 31.4724 38.5844 31.6684 37.607 31.6684H4.50626Z"
          fill="#F15B29"
        />
        <path
          d="M40.9777 24.6816C41.1506 24.6816 41.2484 24.7607 41.2688 24.9201C41.2713 24.9396 41.2726 28.0058 41.2726 28.0299C41.1887 28.7397 41.026 29.2981 40.7883 29.704C40.5494 30.1099 40.1834 30.4838 39.6915 30.8266C39.1996 31.1683 38.5032 31.3403 37.6046 31.3403H4.50383C4.27887 31.3403 4.16703 31.2383 4.16703 31.0364C4.16703 30.8587 4.27887 30.7704 4.50383 30.7704H37.6046C38.3634 30.7704 38.9467 30.6317 39.3547 30.3519C39.7614 30.0732 40.0563 29.7694 40.2393 29.4391C40.4223 29.11 40.5342 28.7982 40.5761 28.5069C40.618 28.2156 40.6396 28.0574 40.6396 28.0322C40.6396 28.007 40.6422 24.9408 40.6435 24.919C40.6676 24.7619 40.7782 24.6839 40.9764 24.6839M40.9777 24.0234C40.4198 24.0234 39.9953 24.3457 39.9216 24.8261L39.919 24.8422V24.8582C39.9101 24.9259 39.9101 27.4359 39.9101 28.0047C39.9038 28.0631 39.8847 28.2019 39.8529 28.4186C39.8212 28.6376 39.7322 28.8807 39.5873 29.141C39.4551 29.3784 39.2289 29.6077 38.9137 29.8244C38.6379 30.0136 38.1969 30.1088 37.6046 30.1088H4.50383C3.87598 30.1088 3.4375 30.4895 3.4375 31.0342C3.4375 31.5788 3.87598 31.9973 4.50383 31.9973H37.6046C38.6646 31.9973 39.5174 31.7783 40.1376 31.3472C40.7108 30.947 41.1468 30.4987 41.4327 30.0125C41.7187 29.5274 41.9042 28.9014 41.9983 28.0998L42.0021 28.0654V28.0299C42.0021 24.9029 41.9996 24.8892 41.9919 24.8364C41.9297 24.3537 41.5204 24.0234 40.9764 24.0234H40.9777Z"
          fill="#F15B29"
        />
        <path
          d="M1.02808 7.645C0.667133 7.645 0.416755 7.44204 0.373542 7.11524C0.371 7.09804 0.367188 7.07281 0.367188 3.96764L0.369729 3.9321C0.458696 3.18332 0.635359 2.58018 0.894634 2.13871C1.15772 1.6938 1.55934 1.27986 2.0906 0.909484C2.64601 0.523058 3.42384 0.328125 4.4012 0.328125H37.502C37.929 0.328125 38.2048 0.576951 38.2048 0.962231C38.2048 1.32458 37.929 1.55735 37.502 1.55735H4.4012C3.72759 1.55735 3.21286 1.67546 2.87224 1.90938C2.51129 2.15591 2.24947 2.42423 2.09187 2.70746C1.92919 3.0033 1.82752 3.28194 1.79066 3.53535C1.7538 3.79106 1.73347 3.93898 1.72965 3.9814C1.72965 6.02591 1.72711 7.08657 1.7233 7.12097C1.67246 7.44663 1.40683 7.64615 1.02808 7.64615V7.645Z"
          fill="#F15B29"
        />
        <path
          d="M37.4995 0.659333C37.7245 0.659333 37.8364 0.760239 37.8364 0.963199C37.8364 1.14093 37.7245 1.22923 37.4995 1.22923H4.39878C3.64002 1.22923 3.05665 1.36797 2.64867 1.64776C2.24197 1.9264 1.94583 2.23026 1.76282 2.5605C1.5798 2.89074 1.46795 3.20149 1.42601 3.49274C1.38407 3.784 1.36246 3.94224 1.36246 3.96861C1.36246 3.99269 1.36119 7.06002 1.35865 7.08066C1.3345 7.23775 1.22393 7.31573 1.02566 7.31573C0.852811 7.31573 0.754948 7.23661 0.734612 7.07722C0.732071 7.05773 0.7308 3.99154 0.7308 3.96861C0.814683 3.25882 0.977365 2.7004 1.2163 2.29448C1.45524 1.88856 1.82128 1.51475 2.31314 1.17189C2.805 0.830186 3.50148 0.659333 4.40005 0.659333H37.5008M37.4995 0.00114667H4.39878C3.3388 0.00114667 2.48726 0.22016 1.86576 0.651306C1.29256 1.05035 0.857895 1.49984 0.570659 1.98602C0.284694 2.47221 0.0991345 3.09829 0.00381287 3.89981L0 3.93421V3.96976C0 7.09671 0.00254191 7.11047 0.0101676 7.16322C0.0724445 7.64597 0.481692 7.97621 1.02566 7.97621C1.56963 7.97621 2.00811 7.65285 2.08183 7.17239C2.08945 7.11965 2.09326 7.08869 2.09326 3.99269C2.09962 3.93421 2.11868 3.79546 2.15046 3.57874C2.18223 3.36202 2.2712 3.11778 2.41736 2.8552C2.54827 2.61898 2.77577 2.38965 3.09096 2.17293C3.36676 1.98373 3.80651 1.88856 4.40005 1.88856H37.5008C38.1287 1.88856 38.5684 1.50787 38.5684 0.963199C38.5684 0.418533 38.1299 0 37.5008 0L37.4995 0.00114667Z"
          fill="#F15B29"
        />
        <path
          d="M13.1416 10.3258C13.1416 11.4552 12.1274 12.3703 10.8755 12.3703C9.6236 12.3703 8.60938 11.4552 8.60938 10.3258C8.60938 9.19629 9.6236 8.28125 10.8755 8.28125C12.1274 8.28125 13.1416 9.19629 13.1416 10.3258Z"
          fill="#F15B29"
        />
        <path
          d="M10.8743 12.7015C9.42291 12.7015 8.24219 11.6362 8.24219 10.3279C8.24219 9.01952 9.42291 7.95312 10.8743 7.95312C12.3258 7.95312 13.5052 9.01838 13.5052 10.3279C13.5052 11.6374 12.3245 12.7015 10.8743 12.7015ZM10.8743 8.61246C9.8258 8.61246 8.97299 9.38187 8.97299 10.3279C8.97299 11.2739 9.8258 12.0433 10.8743 12.0433C11.9229 12.0433 12.7757 11.2739 12.7757 10.3279C12.7757 9.38187 11.9229 8.61246 10.8743 8.61246Z"
          fill="#F7941D"
        />
        <path
          d="M13.1416 20.9586C13.1416 22.088 12.1274 23.0031 10.8755 23.0031C9.6236 23.0031 8.60938 22.088 8.60938 20.9586C8.60938 19.8291 9.6236 18.9141 10.8755 18.9141C12.1274 18.9141 13.1416 19.8291 13.1416 20.9586Z"
          fill="#F15B29"
        />
        <path
          d="M10.8743 23.3343C9.42291 23.3343 8.24219 22.269 8.24219 20.9607C8.24219 19.6523 9.42291 18.5859 10.8743 18.5859C12.3258 18.5859 13.5052 19.6512 13.5052 20.9607C13.5052 22.2702 12.3245 23.3343 10.8743 23.3343ZM10.8743 19.2453C9.8258 19.2453 8.97299 20.0147 8.97299 20.9607C8.97299 21.9067 9.8258 22.6761 10.8743 22.6761C11.9229 22.6761 12.7757 21.9067 12.7757 20.9607C12.7757 20.0147 11.9229 19.2453 10.8743 19.2453Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_7215_70224">
          <rect width="42" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoBlack = (props) => {
  return (
    <svg
      width="96"
      height="80"
      viewBox="0 0 96 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_8612_31594)">
        <path
          d="M30.2231 12.3096C30.2231 12.7568 30.0256 13.0062 29.6276 13.0578C29.5724 13.0664 21.8043 13.0693 21.7433 13.0693C21.6794 13.0693 21.2785 13.118 20.5377 13.2097C19.7969 13.3072 19.0097 13.5595 18.1759 13.9723C17.3422 14.3851 16.5694 15.0501 15.8635 15.9703C15.1576 16.8905 14.8032 18.2063 14.8032 19.9177V36.8454H29.4417C29.9559 36.8454 30.2144 37.069 30.2144 37.5104C30.2144 38.0207 29.9559 38.273 29.4417 38.273H14.8032V66.5096C14.8032 67.0199 14.5795 67.2721 14.1292 67.2721C13.615 67.2721 13.3594 67.0199 13.3594 66.5096V19.9206C13.3594 17.891 13.7922 16.3229 14.6579 15.2135C15.5265 14.1041 16.4765 13.2814 17.502 12.7396C18.5303 12.2007 19.948 11.8366 21.7433 11.6445C21.8043 11.6445 29.5695 11.6445 29.6218 11.6531C30.0256 11.699 30.226 11.9197 30.226 12.3096H30.2231Z"
          fill="#231F20"
        />
        <path
          d="M14.1277 68.9214C12.6897 68.9214 11.6875 67.9296 11.6875 66.5134V19.9215C11.6875 17.5307 12.2395 15.6101 13.3318 14.2083C14.3427 12.9183 15.4786 11.935 16.7132 11.2871C17.9479 10.6421 19.534 10.2236 21.5617 10.0086L21.7389 10C29.6494 10 29.7046 10.0057 29.8237 10.0229C31.0496 10.1605 31.8892 11.0807 31.8892 12.3134C31.8892 13.5461 31.0699 14.5293 29.8498 14.6956C29.7278 14.7128 29.6523 14.7214 21.797 14.7214C21.6489 14.7357 21.3003 14.7787 20.7483 14.8504C20.1993 14.9221 19.5834 15.1256 18.9181 15.4524C18.3197 15.7477 17.7358 16.2608 17.1867 16.9717C16.7103 17.5938 16.4663 18.5857 16.4663 19.9215V35.2008H29.4373C30.8753 35.2008 31.8775 36.1526 31.8775 37.5142C31.8775 38.8759 30.8724 39.9222 29.4373 39.9222H16.4663V66.5105C16.4663 67.9295 15.5018 68.9185 14.1248 68.9185L14.1277 68.9214Z"
          fill="#231F20"
        />
        <path
          d="M79.9611 11.7305C80.4753 11.7305 80.7339 11.9541 80.7339 12.3984V30.0857C80.606 31.1636 80.3794 32.1784 80.0599 33.1301C79.7374 33.9557 79.2552 34.7957 78.6132 35.6499C77.9712 36.507 77.0706 37.1893 75.9173 37.6938C77.0735 38.2012 78.1629 39.0268 79.1942 40.1678C80.2226 41.3087 80.7368 42.9914 80.7368 45.2102V66.5984C80.7368 67.1058 80.4782 67.3581 79.964 67.3581C79.4498 67.3581 79.1942 67.1058 79.1942 66.5984V45.2102C79.1942 43.4988 78.8398 42.183 78.1339 41.2628C77.4279 40.3455 76.6552 39.6776 75.8214 39.2648C74.9848 38.852 74.1975 38.5997 73.4596 38.5051C72.7218 38.4105 72.318 38.3618 72.254 38.3618H65.3139V66.6013C65.3139 67.1087 65.0873 67.361 64.637 67.361C64.1228 67.361 63.8672 67.1087 63.8672 66.6013V12.3984C63.8672 11.9541 64.1228 11.7305 64.637 11.7305C65.0873 11.7305 65.3139 11.9541 65.3139 12.3984V36.937H72.254C73.9884 36.937 75.3218 36.5902 76.2543 35.8907C77.1839 35.1941 77.8608 34.4316 78.2791 33.606C78.6974 32.7833 78.9531 32.0064 79.0518 31.2754C79.1477 30.5473 79.1942 30.1488 79.1942 30.0857V12.3984C79.1942 11.9541 79.4527 11.7305 79.964 11.7305H79.9611Z"
          fill="#231F20"
        />
        <path
          d="M79.9576 69.0074C78.5196 69.0074 77.5174 68.0184 77.5174 66.6022V45.214C77.5174 43.8782 77.2734 42.8863 76.794 42.2585C76.2479 41.5504 75.6669 41.0373 75.0626 40.7392C74.4003 40.4124 73.7815 40.2088 73.2325 40.14C72.6834 40.0684 72.3319 40.0254 72.1808 40.011H66.9721V66.6022C66.9721 68.0184 66.0076 69.0074 64.6277 69.0074C63.2478 69.0074 62.1875 68.0184 62.1875 66.6022V12.3993C62.1875 11.0377 63.1897 10.0859 64.6277 10.0859C66.0657 10.0859 66.9721 11.0377 66.9721 12.3993V35.2896H72.2418C73.5956 35.2896 74.6036 35.0517 75.2311 34.5787C75.9545 34.0369 76.4716 33.4607 76.7737 32.8702C77.1049 32.2194 77.3111 31.6117 77.3838 31.0613C77.4535 30.5224 77.4971 30.1755 77.5116 30.0293V12.3993C77.5116 11.0377 78.5138 10.0859 79.9518 10.0859C81.3898 10.0859 82.3921 11.0377 82.3921 12.3993L82.3804 30.2787C82.241 31.4569 81.9883 32.5893 81.6309 33.6499C81.2271 34.6876 80.6665 35.6652 79.9402 36.6341C79.6584 37.0125 79.336 37.3622 78.9757 37.6862C79.4754 38.0961 79.9576 38.5576 80.4224 39.0765C81.7268 40.5242 82.3892 42.591 82.3892 45.214V66.6022C82.3892 68.0184 81.384 69.0074 79.9489 69.0074H79.9576Z"
          fill="#231F20"
        />
        <path
          d="M54.4157 34.1814C54.7382 33.4848 54.9822 32.834 55.142 32.232C55.2988 31.63 55.4121 30.9162 55.4789 30.0906V20.0114C55.2872 18.237 54.9154 16.8266 54.3692 15.7774C53.826 14.731 52.9748 13.7793 51.8157 12.9222C50.7902 12.1654 49.3958 11.764 47.6731 11.6752C47.586 11.6637 47.5191 11.6465 47.4291 11.6379C47.3535 11.6379 39.3414 11.6264 39.2833 11.6379C38.8331 11.7669 38.6094 12.0192 38.6094 12.4004V66.5947C38.6094 66.976 38.8331 67.2311 39.2833 67.3573C39.3356 67.3659 47.4204 67.3573 47.4291 67.3573C47.5569 67.3458 47.6644 67.32 47.7777 67.3028C49.9071 67.1595 51.653 66.4715 52.9719 65.1729C53.611 64.5393 54.0932 63.8743 54.4128 63.1748C54.7353 62.4782 54.9793 61.8275 55.1391 61.2255C55.2959 60.6235 55.4092 59.9097 55.476 59.0841V45.2123C55.476 42.9935 54.9589 41.3107 53.9306 40.1698C52.9051 39.0289 51.8128 38.2062 50.6566 37.6959C51.5542 37.3146 52.327 36.8101 52.9719 36.1737C53.611 35.5402 54.0932 34.8751 54.4128 34.1756L54.4157 34.1814ZM52.8731 41.2677C53.5791 42.1879 53.9335 43.5037 53.9335 45.2151V59.0869C53.9335 59.6574 53.8376 60.2623 53.6459 60.8958C53.518 61.4061 53.3234 61.9421 53.0649 62.5126C52.8092 63.0831 52.4228 63.6249 51.9087 64.1294C50.6885 65.3334 49.0501 65.9354 46.9962 65.9354C46.9904 65.9354 41.4156 65.8322 40.059 65.8207V38.3638H46.9962C47.0572 38.3638 47.461 38.4126 48.2018 38.5072C48.9397 38.6018 49.727 38.8569 50.5607 39.2668C51.3974 39.6796 52.1701 40.3447 52.876 41.2649L52.8731 41.2677ZM46.9933 36.8445H40.0561V13.1773C41.3721 13.163 44.4979 13.1744 46.1886 13.1744C46.1886 13.1859 47.0689 13.1744 47.1589 13.1744C48.809 13.1974 50.093 13.5385 50.9965 14.2122C51.9261 14.9088 52.6001 15.6713 53.0184 16.4969C53.4338 17.3196 53.6923 18.0965 53.7911 18.8275C53.887 19.5556 53.9335 19.9541 53.9335 20.0172V30.0964C53.9335 30.6668 53.8376 31.2717 53.6459 31.9052C53.518 32.4126 53.3234 32.9516 53.0649 33.522C52.8092 34.0925 52.4228 34.6314 51.9087 35.1388C50.7524 36.2798 49.1169 36.8502 46.9962 36.8502L46.9933 36.8445Z"
          fill="#231F20"
        />
        <path
          d="M41.6108 69.0104C39.159 69.0104 39.1125 69.0018 38.9788 68.976L38.8278 68.9416C37.6658 68.6148 36.9453 67.7147 36.9453 66.5967V12.4024C36.9453 11.2872 37.6658 10.3871 38.8249 10.0574L38.9353 10.0316C39.0883 9.99915 41.8665 9.98673 47.2698 9.99437L47.6155 10.0058C47.7056 10.0144 47.784 10.0288 47.8625 10.0431C49.9018 10.1606 51.5693 10.6881 52.8185 11.6083C54.178 12.6145 55.1977 13.764 55.8571 15.0282C56.505 16.2724 56.9262 17.8462 57.1412 19.8385L57.1499 20.0134L57.1441 30.2244C57.0685 31.1418 56.9407 31.9559 56.7577 32.6468C56.5747 33.3348 56.3074 34.0572 55.9385 34.8627C55.5376 35.7341 54.9391 36.5683 54.1606 37.3423C54.0328 37.4685 53.8991 37.5917 53.7626 37.7093C54.2535 38.1135 54.7271 38.5721 55.1861 39.0795C56.4904 40.5272 57.1528 42.5941 57.1528 45.2171L57.147 59.2207C57.0714 60.1381 56.9436 60.9522 56.7606 61.6431C56.5776 62.3339 56.3103 63.0592 55.9385 63.8619C55.5405 64.7305 54.942 65.5647 54.1606 66.3387C52.5919 67.8838 50.5148 68.7553 47.9816 68.9445C47.8218 68.9731 47.7172 68.9875 47.601 68.9989L47.4354 69.0075C44.6785 69.0104 42.8425 69.0133 41.6137 69.0133L41.6108 69.0104ZM41.7299 64.1915C44.9458 64.2202 46.3315 64.2489 46.9997 64.3005V64.2919C48.6091 64.2919 49.8321 63.859 50.7326 62.9675C51.1016 62.6034 51.3747 62.2279 51.5431 61.8495C51.7639 61.365 51.9266 60.9121 52.0312 60.4964C52.1968 59.9489 52.2694 59.5017 52.2694 59.0889V45.2171C52.2694 43.8783 52.0283 42.8865 51.549 42.2644C51.0028 41.5535 50.4218 41.0432 49.8175 40.7451C49.1552 40.4183 48.5393 40.2147 47.9903 40.1459C47.4412 40.0743 47.0897 40.0313 46.9387 40.0169H41.7328V64.1944L41.7299 64.1915ZM41.7299 35.1981H46.9997C48.673 35.1981 49.8931 34.7939 50.7326 33.9683C51.1016 33.6042 51.3747 33.2287 51.5431 32.8532C51.7639 32.3658 51.9266 31.9158 52.0312 31.5001C52.1968 30.9554 52.2694 30.5054 52.2694 30.0926V20.0707C52.2549 19.9245 52.2113 19.5776 52.1416 19.033C52.069 18.4969 51.8627 17.8892 51.5315 17.2298C51.2294 16.6393 50.7123 16.0631 49.9919 15.5213C49.3934 15.0741 48.4348 14.839 47.1449 14.8218C46.7527 14.8247 46.4477 14.8276 46.1979 14.819V14.8247H44.5188C43.6037 14.8247 42.6043 14.819 41.7357 14.8218V35.2038L41.7299 35.1981Z"
          fill="#231F20"
        />
        <path
          d="M10.2911 79.1789C9.31789 79.1789 8.6875 78.5568 8.6875 77.5936C8.6875 76.6878 9.31789 76.1058 10.2911 76.1058H85.95C87.4897 76.1058 88.6662 75.8106 89.4477 75.2258C90.2698 74.6094 90.8682 73.9386 91.2285 73.2306C91.6003 72.4967 91.8327 71.8001 91.9169 71.1608C92.0012 70.5216 92.0477 70.1489 92.0564 70.0457C92.0564 70.0027 92.0564 62.343 92.068 62.2255C92.1842 61.3827 92.7943 60.8867 93.66 60.8867C94.5257 60.8867 95.0573 61.3941 95.1561 62.2111C95.1619 62.2541 95.1706 62.3172 95.1706 70.0801L95.1648 70.169C94.9614 72.0409 94.5576 73.5516 93.965 74.6524C93.3666 75.7647 92.4457 76.7967 91.2314 77.7226C89.9619 78.6887 88.184 79.1789 85.95 79.1789H10.2911Z"
          fill="#F15B29"
        />
        <path
          d="M93.6578 61.708C94.0529 61.708 94.2766 61.9058 94.323 62.3042C94.3288 62.353 94.3318 70.0184 94.3318 70.0786C94.14 71.8531 93.7682 73.2492 93.2249 74.264C92.6788 75.2788 91.8421 76.2133 90.7179 77.0704C89.5936 77.9247 88.0017 78.3547 85.9478 78.3547H10.2889C9.7747 78.3547 9.51906 78.0995 9.51906 77.595C9.51906 77.1507 9.7747 76.9299 10.2889 76.9299H85.9478C87.6821 76.9299 89.0155 76.5831 89.948 75.8836C90.8777 75.187 91.5516 74.4274 91.97 73.6018C92.3883 72.779 92.6439 71.9993 92.7398 71.2712C92.8357 70.543 92.885 70.1474 92.885 70.0844C92.885 70.0213 92.8909 62.3558 92.8938 62.3014C92.949 61.9086 93.2017 61.7137 93.6549 61.7137M93.6578 60.0625C92.3825 60.0625 91.4122 60.868 91.2437 62.0692L91.2379 62.1093V62.1494C91.2176 62.3186 91.2176 68.5937 91.2176 70.0156C91.203 70.1618 91.1595 70.5086 91.0868 71.0504C91.0142 71.598 90.8109 72.2057 90.4797 72.8564C90.1776 73.4498 89.6604 74.0231 88.94 74.5649C88.3096 75.0379 87.3016 75.2759 85.9478 75.2759H10.2889C8.8538 75.2759 7.85156 76.2276 7.85156 77.5893C7.85156 78.951 8.8538 79.9973 10.2889 79.9973H85.9478C88.3706 79.9973 90.3199 79.4498 91.7376 78.3719C93.0477 77.3714 94.0442 76.2506 94.6978 75.0351C95.3514 73.8225 95.7756 72.2573 95.9905 70.2535L95.9993 70.1675V70.0786C95.9993 62.2612 95.9934 62.2268 95.976 62.095C95.8337 60.8881 94.8982 60.0625 93.6549 60.0625H93.6578Z"
          fill="#F15B29"
        />
        <path
          d="M2.34656 19.1125C1.52153 19.1125 0.949234 18.6051 0.850463 17.7881C0.844653 17.7451 0.835938 17.682 0.835938 9.91911L0.841748 9.83024C1.0451 7.95831 1.4489 6.45044 2.04153 5.34678C2.64287 4.23451 3.56087 3.19964 4.77517 2.27371C6.04468 1.30765 7.82256 0.820312 10.0565 0.820312H85.7154C86.6915 0.820312 87.3219 1.44238 87.3219 2.40558C87.3219 3.31144 86.6915 3.89338 85.7154 3.89338H10.0565C8.51687 3.89338 7.34033 4.18864 6.56177 4.77344C5.73674 5.38978 5.1383 6.06057 4.77808 6.76864C4.40623 7.50824 4.17383 8.20484 4.08958 8.83837C4.00534 9.47764 3.95886 9.84744 3.95014 9.9535C3.95014 15.0648 3.94433 17.7164 3.93562 17.8024C3.81942 18.6166 3.21226 19.1154 2.34656 19.1154V19.1125Z"
          fill="#F15B29"
        />
        <path
          d="M85.7133 1.64443C86.2274 1.64443 86.4831 1.89669 86.4831 2.40409C86.4831 2.84842 86.2274 3.06916 85.7133 3.06916H10.0543C8.32004 3.06916 6.98663 3.41602 6.05411 4.11549C5.12449 4.81209 4.44762 5.57176 4.02929 6.39736C3.61097 7.22295 3.35532 7.99982 3.25946 8.72795C3.16359 9.45609 3.1142 9.85168 3.1142 9.91762C3.1142 9.97782 3.1113 17.6461 3.10549 17.6977C3.05029 18.0905 2.79756 18.2854 2.34437 18.2854C1.94928 18.2854 1.72559 18.0876 1.67911 17.6891C1.6733 17.6404 1.6704 9.97495 1.6704 9.91762C1.86213 8.14315 2.23398 6.74709 2.78012 5.73229C3.32627 4.71749 4.16293 3.78296 5.28718 2.92582C6.41143 2.07156 8.00339 1.64443 10.0573 1.64443H85.7162M85.7133 -0.00103959H10.0543C7.63155 -0.00103959 5.68517 0.546493 4.2646 1.62436C2.95443 2.62196 1.9609 3.74569 1.30436 4.96116C0.650729 6.17662 0.226593 7.74182 0.00871513 9.74562L0 9.83162V9.92048C0 17.7379 0.00581008 17.7723 0.0232403 17.9041C0.165587 19.111 1.10101 19.9366 2.34437 19.9366C3.58773 19.9366 4.58997 19.1282 4.75846 17.9271C4.77589 17.7952 4.7846 17.7178 4.7846 9.97782C4.79913 9.83162 4.8427 9.48475 4.91533 8.94295C4.98796 8.40115 5.19131 7.79055 5.52539 7.13409C5.82461 6.54355 6.34461 5.97022 7.06506 5.42842C7.69546 4.95542 8.7006 4.71749 10.0573 4.71749H85.7162C87.1513 4.71749 88.1564 3.76576 88.1564 2.40409C88.1564 1.04243 87.1542 -0.00390625 85.7162 -0.00390625L85.7133 -0.00103959Z"
          fill="#F15B29"
        />
        <path
          d="M30.0313 25.8261C30.0313 28.6498 27.713 30.9374 24.8516 30.9374C21.9901 30.9374 19.6719 28.6498 19.6719 25.8261C19.6719 23.0024 21.9901 20.7148 24.8516 20.7148C27.713 20.7148 30.0313 23.0024 30.0313 25.8261Z"
          fill="#F15B29"
        />
        <path
          d="M24.8523 31.7615C21.5347 31.7615 18.8359 29.0984 18.8359 25.8275C18.8359 22.5566 21.5347 19.8906 24.8523 19.8906C28.1698 19.8906 30.8657 22.5538 30.8657 25.8275C30.8657 29.1012 28.1669 31.7615 24.8523 31.7615ZM24.8523 21.539C22.4556 21.539 20.5063 23.4625 20.5063 25.8275C20.5063 28.1925 22.4556 30.116 24.8523 30.116C27.2489 30.116 29.1982 28.1925 29.1982 25.8275C29.1982 23.4625 27.2489 21.539 24.8523 21.539Z"
          fill="#F7941D"
        />
        <path
          d="M30.0313 52.4003C30.0313 55.224 27.713 57.5116 24.8516 57.5116C21.9901 57.5116 19.6719 55.224 19.6719 52.4003C19.6719 49.5767 21.9901 47.2891 24.8516 47.2891C27.713 47.2891 30.0313 49.5767 30.0313 52.4003Z"
          fill="#F15B29"
        />
        <path
          d="M24.8523 58.3357C21.5347 58.3357 18.8359 55.6726 18.8359 52.4017C18.8359 49.1308 21.5347 46.4648 24.8523 46.4648C28.1698 46.4648 30.8657 49.128 30.8657 52.4017C30.8657 55.6754 28.1669 58.3357 24.8523 58.3357ZM24.8523 48.1132C22.4556 48.1132 20.5063 50.0367 20.5063 52.4017C20.5063 54.7667 22.4556 56.6902 24.8523 56.6902C27.2489 56.6902 29.1982 54.7667 29.1982 52.4017C29.1982 50.0367 27.2489 48.1132 24.8523 48.1132Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_8612_31594">
          <rect width="96" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Sign = (props) => {
  return (
    <svg
      width="89"
      height="54"
      viewBox="0 0 89 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.0976 5.90283C39.452 1.09272 32.9432 -0.742505 27.3968 0.268719C21.7575 1.29688 17.516 5.20661 17.516 11.0682C17.516 20.0953 24.164 26.3305 31.9774 30.8442C28.199 33.6228 25.3297 36.8567 23.6173 39.9947C23.4365 40.3259 23.2677 40.6579 23.1114 40.9899H1.89362C0.847801 40.9899 0 41.6769 0 42.5244C0 43.3718 0.847801 44.0588 1.89362 44.0588H22.042C21.7801 45.253 21.7178 46.4165 21.8906 47.5119C22.2659 49.8922 23.7677 51.9515 26.6106 53.1034C29.6386 54.3302 32.5529 54.2202 35.142 53.2453C37.6373 52.3058 39.7424 50.6017 41.4596 48.7422C42.8059 47.2844 43.9818 45.6557 44.9731 44.0588H87.1064C88.1522 44.0588 89 43.3718 89 42.5244C89 41.6769 88.1522 40.9899 87.1064 40.9899H46.694C47.3552 39.6814 47.8618 38.5051 48.2035 37.6051C49.0574 35.3563 50.0521 31.0538 50.2657 26.1524C50.6751 26.0481 51.0716 25.9535 51.4552 25.8685C54.0496 25.2935 55.9255 25.1831 57.155 25.3426C58.3384 25.4961 58.6742 25.8478 58.7996 26.0972C58.9786 26.453 59.0369 27.2049 58.372 28.5131C57.5178 30.1939 57.0848 31.7339 57.4962 32.9635C57.7258 33.6495 58.226 34.2514 59.0169 34.635C59.7649 34.9979 60.5887 35.0765 61.3063 35.0401C62.6998 34.9694 64.2238 34.4407 65.6269 33.7559C67.0759 33.0487 68.5862 32.0811 69.9833 30.949C71.2396 29.9309 72.5292 29.0022 73.7427 28.2745C74.9814 27.5316 76.0312 27.0651 76.8166 26.8759C77.1992 26.7837 77.4325 26.7789 77.5484 26.7907C77.6272 26.7986 77.6421 26.8109 77.6513 26.8185C77.7309 26.8801 78.1107 27.2942 78.1107 28.7132C78.1107 31.343 78.9779 33.4097 81.3134 34.1669C82.3719 34.51 83.4632 34.4722 84.3856 34.3165C85.3149 34.1597 86.2167 33.8594 87.0064 33.5394C87.9418 33.1604 88.321 32.2387 87.8533 31.4808C87.3856 30.7228 86.2481 30.4156 85.3127 30.7946C84.6822 31.05 84.1045 31.2292 83.6134 31.3121C83.1154 31.3962 82.8454 31.3582 82.7202 31.3176C82.6774 31.3039 81.8979 31.0543 81.8979 28.7132C81.8979 27.064 81.5062 25.5584 80.2695 24.6012C78.9059 23.5458 77.1383 23.5968 75.7375 23.9343C74.3339 24.2724 72.8692 24.9804 71.4897 25.8077C70.0849 26.6501 68.6526 27.6872 67.3053 28.779C66.0986 29.7568 64.8276 30.5635 63.6728 31.1271C62.7856 31.5601 62.0614 31.8035 61.5419 31.9113C61.3175 31.9579 61.1239 31.7802 61.1658 31.5548C61.2404 31.1538 61.4337 30.5479 61.8739 29.6817C62.7009 28.0546 63.0316 26.3799 62.3067 24.9388C61.5282 23.3912 59.7838 22.5756 57.7536 22.3123C55.7696 22.055 53.2986 22.2783 50.456 22.9084C50.3998 22.9208 50.3434 22.9335 50.2868 22.9463C50.1011 17.1007 48.6194 10.5847 44.0976 5.90283ZM42.5764 40.9899C43.485 39.3352 44.1653 37.8046 44.5837 36.7026C45.2634 34.9126 46.1067 31.4177 46.4073 27.305C45.0496 27.7631 43.5912 28.3048 42.033 28.9361C40.7906 29.4395 39.6041 30.0021 38.4787 30.6115C38.9027 30.8165 39.3296 31.0183 39.7589 31.2171C40.6668 31.6376 40.9821 32.575 40.4632 33.3107C39.9442 34.0464 38.7874 34.3019 37.8794 33.8814C36.9991 33.4736 36.1166 33.0485 35.239 32.6045C31.5951 35.1376 28.8381 38.1324 27.2177 40.9899H42.5764ZM25.9046 44.0588C25.588 45.1955 25.5067 46.2315 25.6472 47.123C25.8878 48.6485 26.758 49.732 28.3043 50.3585C30.2471 51.1456 31.9484 51.0638 33.546 50.4622C35.2374 49.8254 36.8899 48.5685 38.4274 46.9036C39.2468 46.0162 40.0022 45.0477 40.6866 44.0588H25.9046ZM40.3393 26.1913C42.5602 25.2915 44.622 24.5516 46.5191 23.9643C46.5179 23.7983 46.5156 23.6318 46.5122 23.4649C46.3962 17.728 44.9935 11.8098 41.1151 7.79419C37.2395 3.78134 32.1499 2.54771 28.2282 3.26272C24.3994 3.96079 21.3032 6.57237 21.3032 11.0682C21.3032 18.9728 27.3094 24.5475 35.0242 28.8267C36.672 27.8467 38.4486 26.9573 40.3393 26.1913Z"
        fill="black"
      />
      <path
        d="M14.1209 24.1771C14.8604 24.7763 14.8604 25.7478 14.1209 26.3471L10.2524 29.4817L14.1209 32.6164C14.8604 33.2156 14.8604 34.1872 14.1209 34.7864C13.3814 35.3856 12.1824 35.3856 11.4429 34.7864L7.57447 31.6517L3.70601 34.7864C2.96651 35.3856 1.76754 35.3856 1.02803 34.7864C0.288529 34.1872 0.288529 33.2156 1.02803 32.6164L4.89649 29.4817L1.02803 26.3471C0.288529 25.7478 0.28853 24.7763 1.02803 24.1771C1.76754 23.5778 2.96651 23.5778 3.70601 24.1771L7.57447 27.3117L11.4429 24.1771C12.1824 23.5778 13.3814 23.5778 14.1209 24.1771Z"
        fill="black"
      />
    </svg>
  );
};
export const Loader = (props) => {
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" {...props}>
      <path
        d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
        fill="#df1317"
        stroke="none"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="1s"
          repeatCount="indefinite"
          keyTimes="0;1"
          values="0 50 51;360 50 51"
        ></animateTransform>
      </path>
    </svg>
  );
};
export const Notifications = (props) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.89 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.36 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.63 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75Z"
        fill="white"
      />
    </svg>
  );
};
export const Avatar = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="4" fill="#BDBDBD" />
      <path
        d="M16 16C18.21 16 20 14.21 20 12C20 9.79 18.21 8 16 8C13.79 8 12 9.79 12 12C12 14.21 13.79 16 16 16ZM16 18C13.33 18 8 19.34 8 22V24H24V22C24 19.34 18.67 18 16 18Z"
        fill="white"
      />
    </svg>
  );
};
export const ChatFilled = ({ fillClass, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM6 9H18V11H6V9ZM14 14H6V12H14V14ZM18 8H6V6H18V8Z"
        fill="white"
        className={fillClass}
      />
    </svg>
  );
};
export const Icon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4349_45014)">
        <path
          d="M20 6H10V12H8V4H14V0H6V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6Z"
          fill="white"
          {...props}
        />
      </g>
      <defs>
        <clipPath id="clip0_4349_45014">
          <rect width="24" height="24" fill="white" {...props} />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Vector = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H8V18ZM10 18H16C17.1 18 18 17.1 18 16V9H10V18ZM18 7V2C18 0.9 17.1 0 16 0H10V7H18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ArrowUp = (props) => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.6087 11L4.6087 1.96395"
        stroke="#149D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.00004 4.55859L4.55764 1.001L8.11523 4.55859"
        stroke="#149D52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowDown = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6L10.9425 4.9425L6.75 9.1275V0H5.25V9.1275L1.065 4.935L0 6L6 12L12 6Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ArrowDownfill = (props) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0.5L5 5.5L10 0.5H0Z" fill="black" fillOpacity="0.54" />
    </svg>
  );
};
export const ArrowForward = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 0.5L6.59 1.91L12.17 7.5H0V9.5H12.17L6.59 15.09L8 16.5L16 8.5L8 0.5Z"
        fill="white"
      />
    </svg>
  );
};
export const ArrowNext = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2049 6L8.79492 7.41L13.3749 12L8.79492 16.59L10.2049 18L16.2049 12L10.2049 6Z"
        fill="#0000008A"
      />
    </svg>
  );
};
export const ArrowBack = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z"
        fill="#065699"
      />
    </svg>
  );
};
export const TaskAltFilled = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const TaskList = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 0H1.99C0.89 0 0 0.9 0 2L0.00999999 16C0.00999999 17.1 0.9 18 2 18H12L18 12V2C18 0.9 17.1 0 16 0ZM4 5H14V7H4V5ZM9 11H4V9H9V11ZM11 16.5V11H16.5L11 16.5Z"
        fill="#065699"
      />
    </svg>
  );
};
export const ShoppingCart = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 16C4.9 16 4.01 16.9 4.01 18C4.01 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM0 0V2H2L5.6 9.59L4.25 12.04C4.09 12.32 4 12.65 4 13C4 14.1 4.9 15 6 15H18V13H6.42C6.28 13 6.17 12.89 6.17 12.75L6.2 12.63L7.1 11H14.55C15.3 11 15.96 10.59 16.3 9.97L19.88 3.48C19.96 3.34 20 3.17 20 3C20 2.45 19.55 2 19 2H4.21L3.27 0H0ZM16 16C14.9 16 14.01 16.9 14.01 18C14.01 19.1 14.9 20 16 20C17.1 20 18 19.1 18 18C18 16.9 17.1 16 16 16Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Plus = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8334 6.83464H6.83341V11.8346H5.16675V6.83464H0.166748V5.16797H5.16675V0.167969H6.83341V5.16797H11.8334V6.83464Z"
        fill="white"
        {...props}
      />
    </svg>
  );
};
export const Breadcrumbs = (props) => {
  return (
    <svg
      width="7"
      height="19"
      viewBox="0 0 7 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.672 0.927999L2.288 18.72H0.848L5.216 0.927999H6.672Z"
        fill="black"
        fillOpacity="0.6"
      />
    </svg>
  );
};
export const OutVector = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Search = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.7549 11.2539H11.9649L11.6849 10.9839C12.6649 9.84391 13.2549 8.36391 13.2549 6.75391C13.2549 3.16391 10.3449 0.253906 6.75488 0.253906C3.16488 0.253906 0.254883 3.16391 0.254883 6.75391C0.254883 10.3439 3.16488 13.2539 6.75488 13.2539C8.36488 13.2539 9.84488 12.6639 10.9849 11.6839L11.2549 11.9639V12.7539L16.2549 17.7439L17.7449 16.2539L12.7549 11.2539ZM6.75488 11.2539C4.26488 11.2539 2.25488 9.24391 2.25488 6.75391C2.25488 4.26391 4.26488 2.25391 6.75488 2.25391C9.24488 2.25391 11.2549 4.26391 11.2549 6.75391C11.2549 9.24391 9.24488 11.2539 6.75488 11.2539Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Edit = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.499023 12.3771V15.5021H3.62402L12.8407 6.28542L9.71569 3.16042L0.499023 12.3771ZM15.2574 3.86875C15.5824 3.54375 15.5824 3.01875 15.2574 2.69375L13.3074 0.74375C12.9824 0.41875 12.4574 0.41875 12.1324 0.74375L10.6074 2.26875L13.7324 5.39375L15.2574 3.86875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const TechnicianCircle = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 12C5.1 12 6 12.9 6 14C6 15.1 5.1 16 4 16C2.9 16 2 15.1 2 14C2 12.9 2.9 12 4 12ZM4 10C1.8 10 0 11.8 0 14C0 16.2 1.8 18 4 18C6.2 18 8 16.2 8 14C8 11.8 6.2 10 4 10ZM10 2C11.1 2 12 2.9 12 4C12 5.1 11.1 6 10 6C8.9 6 8 5.1 8 4C8 2.9 8.9 2 10 2ZM10 0C7.8 0 6 1.8 6 4C6 6.2 7.8 8 10 8C12.2 8 14 6.2 14 4C14 1.8 12.2 0 10 0ZM16 12C17.1 12 18 12.9 18 14C18 15.1 17.1 16 16 16C14.9 16 14 15.1 14 14C14 12.9 14.9 12 16 12ZM16 10C13.8 10 12 11.8 12 14C12 16.2 13.8 18 16 18C18.2 18 20 16.2 20 14C20 11.8 18.2 10 16 10Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DateIcon = (props) => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 9H4V11H6V9ZM10 9H8V11H10V9ZM14 9H12V11H14V9ZM16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V7H16V18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Trash = (props) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.00008 13.8333C1.00008 14.75 1.75008 15.5 2.66675 15.5H9.33341C10.2501 15.5 11.0001 14.75 11.0001 13.8333V3.83333H1.00008V13.8333ZM3.05008 7.9L4.22508 6.725L6.00008 8.49167L7.76675 6.725L8.94175 7.9L7.17508 9.66667L8.94175 11.4333L7.76675 12.6083L6.00008 10.8417L4.23341 12.6083L3.05841 11.4333L4.82508 9.66667L3.05008 7.9ZM8.91675 1.33333L8.08341 0.5H3.91675L3.08341 1.33333H0.166748V3H11.8334V1.33333H8.91675Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const RippleLoaderSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200px"
    height="200px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    fill="none"
  >
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-themeBtn"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="0s"
      ></animate>
    </circle>
    <circle
      cx="50"
      cy="50"
      r="0"
      fill="none"
      className="stroke-themeBtn"
      strokeWidth="2"
    >
      <animate
        attributeName="r"
        repeatCount="indefinite"
        dur="1s"
        values="0;40"
        keyTimes="0;1"
        keySplines="0 0.2 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="1s"
        values="1;0"
        keyTimes="0;1"
        keySplines="0.2 0 0.8 1"
        calcMode="spline"
        begin="-0.5s"
      ></animate>
    </circle>
  </svg>
);
export const CancelCircle = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.20003 0.667969C4.5917 0.667969 0.866699 4.39297 0.866699 9.0013C0.866699 13.6096 4.5917 17.3346 9.20003 17.3346C13.8084 17.3346 17.5334 13.6096 17.5334 9.0013C17.5334 4.39297 13.8084 0.667969 9.20003 0.667969ZM13.3667 11.993L12.1917 13.168L9.20003 10.1763L6.20837 13.168L5.03337 11.993L8.02503 9.0013L5.03337 6.00964L6.20837 4.83464L9.20003 7.8263L12.1917 4.83464L13.3667 6.00964L10.375 9.0013L13.3667 11.993Z"
        fill="#C62828"
      />
    </svg>
  );
};
export const CheckCircleOutline = ({ pathClass, ...props }) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2077 5.44801L8.16683 11.4888L4.876 8.20717L3.5835 9.49967L8.16683 14.083L15.5002 6.74967L14.2077 5.44801ZM10.0002 0.333008C4.94016 0.333008 0.833496 4.43967 0.833496 9.49967C0.833496 14.5597 4.94016 18.6663 10.0002 18.6663C15.0602 18.6663 19.1668 14.5597 19.1668 9.49967C19.1668 4.43967 15.0602 0.333008 10.0002 0.333008ZM10.0002 16.833C5.9485 16.833 2.66683 13.5513 2.66683 9.49967C2.66683 5.44801 5.9485 2.16634 10.0002 2.16634C14.0518 2.16634 17.3335 5.44801 17.3335 9.49967C17.3335 13.5513 14.0518 16.833 10.0002 16.833Z"
        fill={"#2E7D6F"}
        className={pathClass}
      />
    </svg>
  );
};
export const CheckCircle = ({ pathClass, ...props }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.39974 0.667969C3.79974 0.667969 0.0664062 4.4013 0.0664062 9.0013C0.0664062 13.6013 3.79974 17.3346 8.39974 17.3346C12.9997 17.3346 16.7331 13.6013 16.7331 9.0013C16.7331 4.4013 12.9997 0.667969 8.39974 0.667969ZM6.73307 13.168L2.56641 9.0013L3.74141 7.8263L6.73307 10.8096L13.0581 4.48464L14.2331 5.66797L6.73307 13.168Z"
        fill="#2E7D6F"
        className={pathClass}
      />
    </svg>
  );
};
export const Close = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const People = (props) => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V14H14V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C15.19 8.89 16 10.02 16 11.5V14H22V11.5C22 9.17 17.33 8 15 8Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const EngineeringOutlined = (props) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 12C5.33 12 0 13.34 0 16V18H16V16C16 13.34 10.67 12 8 12ZM2 16C2.22 15.28 5.31 14 8 14C10.7 14 13.8 15.29 14 16H2Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M3.74 6H4C4 8.21 5.79 10 8 10C10.21 10 12 8.21 12 6H12.26C12.53 6 12.75 5.78 12.75 5.51V5.49C12.75 5.22 12.53 5 12.26 5H12C12 3.52 11.19 2.25 10 1.55V2.5C10 2.78 9.78 3 9.5 3C9.22 3 9 2.78 9 2.5V1.14C8.68 1.06 8.35 1 8 1C7.65 1 7.32 1.06 7 1.14V2.5C7 2.78 6.78 3 6.5 3C6.22 3 6 2.78 6 2.5V1.55C4.81 2.25 4 3.52 4 5H3.74C3.47 5 3.25 5.22 3.25 5.49V5.52C3.25 5.78 3.47 6 3.74 6ZM10 6C10 7.1 9.1 8 8 8C6.9 8 6 7.1 6 6H10Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M20.9801 3.23L21.9101 2.4L21.1601 1.1L19.9701 1.49C19.8301 1.38 19.6701 1.29 19.5001 1.22L19.2501 0H17.7501L17.5001 1.22C17.3301 1.29 17.1701 1.38 17.0201 1.49L15.8401 1.1L15.0901 2.4L16.0201 3.23C16.0001 3.4 16.0001 3.58 16.0201 3.75L15.0901 4.6L15.8401 5.9L17.0401 5.52C17.1701 5.62 17.3201 5.7 17.4701 5.77L17.7501 7H19.2501L19.5201 5.78C19.6801 5.71 19.8201 5.63 19.9601 5.53L21.1501 5.91L21.9001 4.61L20.9701 3.76C21.0001 3.57 20.9901 3.4 20.9801 3.23ZM18.5001 4.75C17.8101 4.75 17.2501 4.19 17.2501 3.5C17.2501 2.81 17.8101 2.25 18.5001 2.25C19.1901 2.25 19.7501 2.81 19.7501 3.5C19.7501 4.19 19.1901 4.75 18.5001 4.75Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18.4001 7.79L17.5501 8.07C17.4501 7.99 17.3401 7.93 17.2201 7.88L17.0401 7H15.9701L15.7901 7.87C15.6701 7.92 15.5501 7.99 15.4501 8.06L14.6101 7.78L14.0701 8.71L14.7301 9.3C14.7201 9.43 14.7201 9.55 14.7301 9.67L14.0701 10.28L14.6101 11.21L15.4701 10.94C15.5701 11.01 15.6701 11.07 15.7801 11.12L15.9601 12H17.0301L17.2201 11.13C17.3301 11.08 17.4401 11.02 17.5401 10.95L18.3901 11.22L18.9301 10.29L18.2701 9.68C18.2801 9.55 18.2801 9.43 18.2701 9.31L18.9301 8.72L18.4001 7.79ZM16.5001 10.39C16.0101 10.39 15.6101 9.99 15.6101 9.5C15.6101 9.01 16.0101 8.61 16.5001 8.61C16.9901 8.61 17.3901 9.01 17.3901 9.5C17.3901 9.99 16.9901 10.39 16.5001 10.39Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const GroupsOutlined = (props) => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 7C5.1 7 6 6.1 6 5C6 3.9 5.1 3 4 3C2.9 3 2 3.9 2 5C2 6.1 2.9 7 4 7ZM5.13 8.1C4.76 8.04 4.39 8 4 8C3.01 8 2.07 8.21 1.22 8.58C0.48 8.9 0 9.62 0 10.43V12H4.5V10.39C4.5 9.56 4.73 8.78 5.13 8.1ZM20 7C21.1 7 22 6.1 22 5C22 3.9 21.1 3 20 3C18.9 3 18 3.9 18 5C18 6.1 18.9 7 20 7ZM24 10.43C24 9.62 23.52 8.9 22.78 8.58C21.93 8.21 20.99 8 20 8C19.61 8 19.24 8.04 18.87 8.1C19.27 8.78 19.5 9.56 19.5 10.39V12H24V10.43ZM16.24 7.65C15.07 7.13 13.63 6.75 12 6.75C10.37 6.75 8.93 7.14 7.76 7.65C6.68 8.13 6 9.21 6 10.39V12H18V10.39C18 9.21 17.32 8.13 16.24 7.65ZM8.07 10C8.16 9.77 8.2 9.61 8.98 9.31C9.95 8.93 10.97 8.75 12 8.75C13.03 8.75 14.05 8.93 15.02 9.31C15.79 9.61 15.83 9.77 15.93 10H8.07ZM12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4C11.45 4 11 3.55 11 3C11 2.45 11.45 2 12 2ZM12 0C10.34 0 9 1.34 9 3C9 4.66 10.34 6 12 6C13.66 6 15 4.66 15 3C15 1.34 13.66 0 12 0Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Work = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 4H14V2C14 0.89 13.11 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0.00999999 4.89 0.00999999 6L0 17C0 18.11 0.89 19 2 19H18C19.11 19 20 18.11 20 17V6C20 4.89 19.11 4 18 4ZM12 4H8V2H12V4Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const MarkunreadMailbox = (props) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 6H8V12H6V4H12V0H4V6H2C0.9 6 0 6.9 0 8V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const MoreVert = (props) => {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.99992 3.66732C2.91659 3.66732 3.66659 2.91732 3.66659 2.00065C3.66659 1.08398 2.91659 0.333984 1.99992 0.333984C1.08325 0.333984 0.333252 1.08398 0.333252 2.00065C0.333252 2.91732 1.08325 3.66732 1.99992 3.66732ZM1.99992 5.33398C1.08325 5.33398 0.333252 6.08398 0.333252 7.00065C0.333252 7.91732 1.08325 8.66732 1.99992 8.66732C2.91659 8.66732 3.66659 7.91732 3.66659 7.00065C3.66659 6.08398 2.91659 5.33398 1.99992 5.33398ZM1.99992 10.334C1.08325 10.334 0.333252 11.084 0.333252 12.0007C0.333252 12.9173 1.08325 13.6673 1.99992 13.6673C2.91659 13.6673 3.66659 12.9173 3.66659 12.0007C3.66659 11.084 2.91659 10.334 1.99992 10.334Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DisableMoreVert = (props) => {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33854 3.66536C3.25521 3.66536 4.00521 2.91536 4.00521 1.9987C4.00521 1.08203 3.25521 0.332031 2.33854 0.332031C1.42188 0.332031 0.671875 1.08203 0.671875 1.9987C0.671875 2.91536 1.42188 3.66536 2.33854 3.66536ZM2.33854 5.33203C1.42188 5.33203 0.671875 6.08203 0.671875 6.9987C0.671875 7.91536 1.42188 8.66536 2.33854 8.66536C3.25521 8.66536 4.00521 7.91536 4.00521 6.9987C4.00521 6.08203 3.25521 5.33203 2.33854 5.33203ZM2.33854 10.332C1.42188 10.332 0.671875 11.082 0.671875 11.9987C0.671875 12.9154 1.42188 13.6654 2.33854 13.6654C3.25521 13.6654 4.00521 12.9154 4.00521 11.9987C4.00521 11.082 3.25521 10.332 2.33854 10.332Z"
        fill="black"
        fill-opacity="0.26"
      />
    </svg>
  );
};
export const Eye = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 13C8.24 13 6 10.76 6 8C6 5.24 8.24 3 11 3C13.76 3 16 5.24 16 8C16 10.76 13.76 13 11 13ZM11 5C9.34 5 8 6.34 8 8C8 9.66 9.34 11 11 11C12.66 11 14 9.66 14 8C14 6.34 12.66 5 11 5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const EyeSlash = (props) => {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 2C6 2 1.73 5.11 0 9.5C1.73 13.89 6 17 11 17C16 17 20.27 13.89 22 9.5C20.27 5.11 16 2 11 2ZM11 14.5C8.24 14.5 6 12.26 6 9.5C6 6.74 8.24 4.5 11 4.5C13.76 4.5 16 6.74 16 9.5C16 12.26 13.76 14.5 11 14.5ZM11 6.5C9.34 6.5 8 7.84 8 9.5C8 11.16 9.34 12.5 11 12.5C12.66 12.5 14 11.16 14 9.5C14 7.84 12.66 6.5 11 6.5Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18 2L4 17"
        stroke="#707070"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const MailBox = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const User = ({ fillOpacity, pathClass, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        className={pathClass}
      />
    </svg>
  );
};
export const FileDownload = ({ fillColor, ...props }) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z"
        fill="#065699"
        className={fillColor}
      />
    </svg>
  );
};
export const FileUpload = (props) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_4634_16718)">
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          fill="white"
        />
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          stroke="#E0E0E0"
        />
        <path
          d="M20.165 23.3339C20.165 23.795 20.5388 24.1689 21 24.1689C21.4612 24.1689 21.835 23.795 21.835 23.3339H20.165ZM21.835 14.1672C21.835 13.706 21.4612 13.3322 21 13.3322C20.5388 13.3322 20.165 13.706 20.165 14.1672L21.835 14.1672ZM23.7429 16.4243C24.069 16.7504 24.5977 16.7504 24.9238 16.4243C25.2499 16.0982 25.2499 15.5695 24.9238 15.2434L23.7429 16.4243ZM21.5893 13.0898L20.9988 13.6802L21.5893 13.0898ZM20.4107 13.0898L21.0012 13.6802L21.0012 13.6802L20.4107 13.0898ZM17.0762 15.2434C16.7501 15.5695 16.7501 16.0982 17.0762 16.4243C17.4023 16.7504 17.931 16.7504 18.2571 16.4243L17.0762 15.2434ZM14.335 23.3339C14.335 22.8727 13.9612 22.4989 13.5 22.4989C13.0388 22.4989 12.665 22.8727 12.665 23.3339H14.335ZM29.335 23.3339C29.335 22.8727 28.9612 22.4989 28.5 22.4989C28.0388 22.4989 27.665 22.8727 27.665 23.3339H29.335ZM27.135 27.228L26.7559 26.4841H26.7559L27.135 27.228ZM28.2275 26.1355L28.9715 26.5146V26.5146L28.2275 26.1355ZM13.7725 26.1355L13.0285 26.5146L13.7725 26.1355ZM14.865 27.228L14.4859 27.972H14.4859L14.865 27.228ZM21.835 23.3339L21.835 14.1672L20.165 14.1672L20.165 23.3339H21.835ZM24.9238 15.2434L22.1797 12.4993L20.9988 13.6802L23.7429 16.4243L24.9238 15.2434ZM19.8203 12.4993L17.0762 15.2434L18.2571 16.4243L21.0012 13.6802L19.8203 12.4993ZM22.1797 12.4993C21.5282 11.8478 20.4718 11.8478 19.8203 12.4993L21.0012 13.6802C21.0021 13.6793 21.0016 13.68 21.0002 13.6805C20.9994 13.6808 20.9994 13.6807 21 13.6807C21.0006 13.6807 21.0006 13.6808 20.9998 13.6805C20.9984 13.68 20.9979 13.6793 20.9988 13.6802L22.1797 12.4993ZM12.665 23.3339V23.5005H14.335V23.3339H12.665ZM17.5 28.3355H24.5V26.6655H17.5V28.3355ZM29.335 23.5005V23.3339H27.665V23.5005H29.335ZM24.5 28.3355C25.1863 28.3355 25.7512 28.3362 26.21 28.2987C26.6785 28.2604 27.1093 28.1782 27.5141 27.972L26.7559 26.4841C26.6258 26.5503 26.4392 26.6044 26.074 26.6342C25.699 26.6649 25.2138 26.6655 24.5 26.6655V28.3355ZM27.665 23.5005C27.665 24.2144 27.6644 24.6995 27.6337 25.0745C27.6039 25.4398 27.5498 25.6264 27.4835 25.7564L28.9715 26.5146C29.1777 26.1099 29.2599 25.679 29.2982 25.2105C29.3356 24.7517 29.335 24.1868 29.335 23.5005H27.665ZM27.5141 27.972C28.1416 27.6523 28.6518 27.1421 28.9715 26.5146L27.4835 25.7564C27.3239 26.0697 27.0692 26.3244 26.7559 26.4841L27.5141 27.972ZM12.665 23.5005C12.665 24.1868 12.6644 24.7517 12.7018 25.2105C12.7401 25.679 12.8223 26.1099 13.0285 26.5146L14.5165 25.7564C14.4502 25.6264 14.3961 25.4398 14.3663 25.0745C14.3356 24.6995 14.335 24.2144 14.335 23.5005H12.665ZM17.5 26.6655C16.7862 26.6655 16.301 26.6649 15.926 26.6342C15.5608 26.6044 15.3742 26.5503 15.2441 26.4841L14.4859 27.972C14.8907 28.1782 15.3215 28.2604 15.79 28.2987C16.2488 28.3362 16.8137 28.3355 17.5 28.3355V26.6655ZM13.0285 26.5146C13.3482 27.1421 13.8584 27.6523 14.4859 27.972L15.2441 26.4841C14.9308 26.3244 14.6761 26.0697 14.5165 25.7564L13.0285 26.5146Z"
          fill="black"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4634_16718"
          x="0.5"
          y="0.5"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4634_16718"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4634_16718"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const PDFDoc = (props) => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0003 5.85325V34.2769C27.0003 34.9505 26.4518 35.5 25.7795 35.5H3.27358C2.60123 35.5 2.05273 34.9505 2.05273 34.2769V1.72309C2.05273 1.04951 2.60123 0.5 3.27358 0.5H21.6481L27.0003 5.85325Z"
        fill="white"
      />
      <path
        d="M27.0002 5.85325V34.2769C27.0002 34.9505 26.4517 35.5 25.7794 35.5H24.0366C24.7089 35.5 25.2574 34.9505 25.2574 34.2769V5.85325L19.9141 0.5H21.6569L27.0002 5.85325Z"
        fill="#E5E5E5"
      />
      <path
        d="M26.9997 5.85325H22.8683C22.196 5.85325 21.6475 5.30375 21.6475 4.63016V0.5L26.9997 5.85325Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 17.0734H7.35146C6.8649 17.0734 6.4668 16.6745 6.4668 16.1871C6.4668 15.6996 6.8649 15.3008 7.35146 15.3008H21.8423C22.3289 15.3008 22.727 15.6996 22.727 16.1871C22.727 16.6834 22.3377 17.0734 21.8423 17.0734Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 21.6203H7.35146C6.8649 21.6203 6.4668 21.2214 6.4668 20.734C6.4668 20.2465 6.8649 19.8477 7.35146 19.8477H21.8423C22.3289 19.8477 22.727 20.2465 22.727 20.734C22.727 21.2303 22.3377 21.6203 21.8423 21.6203Z"
        fill="#CECECE"
      />
      <path
        d="M21.8423 26.1671H7.35146C6.8649 26.1671 6.4668 25.7683 6.4668 25.2808C6.4668 24.7934 6.8649 24.3945 7.35146 24.3945H21.8423C22.3289 24.3945 22.727 24.7934 22.727 25.2808C22.727 25.7772 22.3377 26.1671 21.8423 26.1671Z"
        fill="#CECECE"
      />
      <path
        d="M12.2526 12.4651H0V7.493C0 7.12075 0.300782 6.81055 0.681188 6.81055H12.2526C12.6242 6.81055 12.9338 7.11189 12.9338 7.493V11.7827C12.9338 12.1549 12.633 12.4651 12.2526 12.4651Z"
        fill="#F55B4B"
      />
      <path
        d="M12.9338 11.6941V11.7827C12.9338 12.1549 12.633 12.4651 12.2526 12.4651H0V7.493C0 7.12075 0.300782 6.81055 0.681188 6.81055H1.02621V8.58315C1.02621 10.3026 2.41514 11.7029 4.14023 11.7029H12.9338V11.6941Z"
        fill="#DD4E43"
      />
      <path d="M0 12.4648L2.05242 14.8047V12.4648H0Z" fill="#DB1B1B" />
      <path
        d="M3.3177 10.7099V11.3038H1.46875V10.7099H1.91993V8.37898H1.46875V7.78516H3.3177C3.75119 7.78516 4.07852 7.88265 4.31738 8.0865C4.55624 8.29035 4.67124 8.5651 4.67124 8.9019C4.67124 9.09688 4.62701 9.27414 4.54739 9.43368C4.46777 9.59321 4.36161 9.71729 4.22891 9.79706C4.09621 9.88569 3.95466 9.93887 3.78658 9.97432C3.61849 10.0098 3.41502 10.0186 3.16731 10.0186H2.83114V10.7011H3.3177V10.7099ZM2.83114 9.43368H2.96384C3.27347 9.43368 3.47694 9.3805 3.56541 9.283C3.65388 9.18551 3.69811 9.05257 3.69811 8.9019C3.69811 8.77781 3.66272 8.66259 3.60079 8.57396C3.53887 8.48533 3.4681 8.43216 3.38848 8.40557C3.30886 8.38784 3.17616 8.37011 2.99038 8.37011H2.82229V9.43368H2.83114Z"
        fill="white"
      />
      <path
        d="M4.88379 11.3038V10.7099H5.41459V8.37898H4.88379V7.78516H6.54697C6.90083 7.78516 7.17508 7.80288 7.39624 7.8472C7.60856 7.89151 7.81204 7.989 8.00666 8.13081C8.20129 8.28148 8.36053 8.47647 8.47554 8.72464C8.59054 8.9728 8.65247 9.24755 8.65247 9.54889C8.65247 9.79706 8.60823 10.0275 8.52861 10.2491C8.44899 10.4706 8.34283 10.6479 8.21898 10.7897C8.09513 10.9227 7.95358 11.0379 7.77665 11.1176C7.60856 11.1974 7.44932 11.2506 7.30778 11.2772C7.16623 11.3038 6.94506 11.3126 6.64428 11.3126H4.88379V11.3038ZM6.33464 10.7099H6.55581C6.82121 10.7099 7.03353 10.6745 7.19277 10.6036C7.35201 10.5327 7.47586 10.4086 7.56433 10.2402C7.66164 10.0629 7.70588 9.84137 7.70588 9.55776C7.70588 9.29187 7.66164 9.06143 7.56433 8.87531C7.46702 8.68918 7.34316 8.55624 7.17508 8.48533C7.01584 8.41443 6.80352 8.37898 6.55581 8.37898H6.33464V10.7099Z"
        fill="white"
      />
      <path
        d="M9.05957 11.3038V10.7099H9.56383V8.37898H9.05957V7.78516H12.209V8.87531H11.5366V8.38784H10.4839V9.20324H11.2447V9.79706H10.4839V10.7099H11.0235V11.3038H9.05957Z"
        fill="white"
      />
      <path
        d="M10.9082 14.1134H2.06152V12.4648H12.2971V12.7307C12.2883 13.493 11.669 14.1134 10.9082 14.1134Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};
export const CompaniesIcon = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z"
        fill="black"
        fillOpacity="0.54"
        {...props}
      />
    </svg>
  );
};
export const Folder = (props) => {
  return (
    <svg
      width="80"
      height="64"
      viewBox="0 0 80 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.1663 0.666992H8.66634C4.35801 0.666992 0.872174 4.19199 0.872174 8.50033L0.833008 55.5003C0.833008 59.8087 4.35801 63.3337 8.66634 63.3337H71.333C75.6413 63.3337 79.1663 59.8087 79.1663 55.5003V16.3337C79.1663 12.0253 75.6413 8.50033 71.333 8.50033H39.9997L32.1663 0.666992Z"
        fill="#065699"
      />
    </svg>
  );
};
export const UpArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 0.296875L0 6.29688L1.41 7.70687L6 3.12687L10.59 7.70687L12 6.29688L6 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const SortDownArrow = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 6L10.9425 4.9425L6.75 9.1275V0H5.25V9.1275L1.065 4.935L0 6L6 12L12 6Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const History = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33073 5H1.66406V16.6667C1.66406 17.5833 2.41406 18.3333 3.33073 18.3333H14.9974V16.6667H3.33073V5Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M16.6667 1.66406H6.66667C5.75 1.66406 5 2.41406 5 3.33073V13.3307C5 14.2474 5.75 14.9974 6.66667 14.9974H16.6667C17.5833 14.9974 18.3333 14.2474 18.3333 13.3307V3.33073C18.3333 2.41406 17.5833 1.66406 16.6667 1.66406ZM16.6667 9.9974L14.5833 8.7474L12.5 9.9974V3.33073H16.6667V9.9974Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DownArrow = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70687L6 7.70687L12 1.70687L10.59 0.296875Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const DownArrowAction = (props) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.59 0.296875L6 4.87687L1.41 0.296875L0 1.70687L6 7.70687L12 1.70687L10.59 0.296875Z"
        fill="#F15B29"
      />
    </svg>
  );
};
export const BackArrow = ({ fillOpacity, ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
        fill="black"
        fillOpacity={fillOpacity ?? "0.54"}
        {...props}
      />
    </svg>
  );
};
export const Campaign = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 7V9H20V7H16ZM14 13.61C14.96 14.32 16.21 15.26 17.2 16C17.6 15.47 18 14.93 18.4 14.4C17.41 13.66 16.16 12.72 15.2 12C14.8 12.54 14.4 13.08 14 13.61ZM18.4 1.6C18 1.07 17.6 0.53 17.2 0C16.21 0.74 14.96 1.68 14 2.4C14.4 2.93 14.8 3.47 15.2 4C16.16 3.28 17.41 2.35 18.4 1.6ZM2 5C0.9 5 0 5.9 0 7V9C0 10.1 0.9 11 2 11H3V15H5V11H6L11 14V2L6 5H2ZM13.5 8C13.5 6.67 12.92 5.47 12 4.65V11.34C12.92 10.53 13.5 9.33 13.5 8Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Star = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 15.77L16.18 19.5L14.54 12.47L20 7.74L12.81 7.13L10 0.5L7.19 7.13L0 7.74L5.46 12.47L3.82 19.5L10 15.77Z"
        fill="#065699"
      />
    </svg>
  );
};
export const Clock = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Location = (props) => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z"
        fill="#065699"
      />
    </svg>
  );
};
export const Settings = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.1401 10.9384C17.1801 10.6384 17.2001 10.3284 17.2001 9.99844C17.2001 9.67844 17.1801 9.35844 17.1301 9.05844L19.1601 7.47844C19.3401 7.33844 19.3901 7.06844 19.2801 6.86844L17.3601 3.54844C17.2401 3.32844 16.9901 3.25844 16.7701 3.32844L14.3801 4.28844C13.8801 3.90844 13.3501 3.58844 12.7601 3.34844L12.4001 0.808437C12.3601 0.568437 12.1601 0.398438 11.9201 0.398438H8.08011C7.84011 0.398438 7.65011 0.568437 7.61011 0.808437L7.25011 3.34844C6.66011 3.58844 6.12011 3.91844 5.63011 4.28844L3.24011 3.32844C3.02011 3.24844 2.77011 3.32844 2.65011 3.54844L0.74011 6.86844C0.62011 7.07844 0.66011 7.33844 0.86011 7.47844L2.89011 9.05844C2.84011 9.35844 2.80011 9.68844 2.80011 9.99844C2.80011 10.3084 2.82011 10.6384 2.87011 10.9384L0.84011 12.5184C0.66011 12.6584 0.61011 12.9284 0.72011 13.1284L2.64011 16.4484C2.76011 16.6684 3.01011 16.7384 3.23011 16.6684L5.62011 15.7084C6.12011 16.0884 6.65011 16.4084 7.24011 16.6484L7.60011 19.1884C7.65011 19.4284 7.84011 19.5984 8.08011 19.5984H11.9201C12.1601 19.5984 12.3601 19.4284 12.3901 19.1884L12.7501 16.6484C13.3401 16.4084 13.8801 16.0884 14.3701 15.7084L16.7601 16.6684C16.9801 16.7484 17.2301 16.6684 17.3501 16.4484L19.2701 13.1284C19.3901 12.9084 19.3401 12.6584 19.1501 12.5184L17.1401 10.9384ZM10.0001 13.5984C8.02011 13.5984 6.40011 11.9784 6.40011 9.99844C6.40011 8.01844 8.02011 6.39844 10.0001 6.39844C11.9801 6.39844 13.6001 8.01844 13.6001 9.99844C13.6001 11.9784 11.9801 13.5984 10.0001 13.5984Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const General = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.89 0 0 0.89 0 2V14C0 15.1 0.89 16 2 16H6V18H14V16H18C19.1 16 20 15.1 20 14V2C20 0.89 19.1 0 18 0ZM18 14H2V2H18V14Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path d="M12 5.25H4V6.75H12V5.25Z" fill="black" fillOpacity="0.54" />
      <path
        d="M14.5 6.75H16V5.25H14.5V4H13V8H14.5V6.75Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path d="M16 9.25H8V10.75H16V9.25Z" fill="black" fillOpacity="0.54" />
      <path
        d="M5.5 12H7V8H5.5V9.25H4V10.75H5.5V12Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Service = (props) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4V2H8V4H12ZM2 6V17H18V6H2ZM18 4C19.11 4 20 4.89 20 6V17C20 18.11 19.11 19 18 19H2C0.89 19 0 18.11 0 17L0.00999999 6C0.00999999 4.89 0.89 4 2 4H6V2C6 0.89 6.89 0 8 0H12C13.11 0 14 0.89 14 2V4H18Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ActivityLog = (props) => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0C7.03 0 3 4.03 3 9H0L3.89 12.89L3.96 13.03L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.07 16 8.32 15.21 7.06 13.94L5.64 15.36C7.27 16.99 9.51 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0ZM11 5V10L15.28 12.54L16 11.33L12.5 9.25V5H11Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Send = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0114286 24L24 12L0.0114286 0L0 9.33333L17.1429 12L0 14.6667L0.0114286 24Z"
        fill="#065699"
      />
    </svg>
  );
};
export const EarnPocket = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 15.6328C16.2761 15.6328 16.5 15.409 16.5 15.1328C16.5 14.8567 16.2761 14.6328 16 14.6328C15.7239 14.6328 15.5 14.8567 15.5 15.1328C15.5 15.409 15.7239 15.6328 16 15.6328Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M4 7.13281V5.63281C4 5.3676 4.10536 5.11324 4.29289 4.92571C4.48043 4.73817 4.73478 4.63281 5 4.63281H9"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M8.42188 8.55879L11.6319 2.99879C11.7647 2.76956 11.983 2.60238 12.2389 2.53394C12.4948 2.46551 12.7674 2.50142 12.9969 2.63379L21.2219 7.38379C21.3358 7.44912 21.4357 7.53625 21.516 7.6402C21.5962 7.74416 21.6552 7.8629 21.6896 7.98966C21.7239 8.11641 21.733 8.24869 21.7162 8.37894C21.6995 8.50919 21.6572 8.63487 21.5919 8.74879"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M19.5 9.63281H20.5C20.7652 9.63281 21.0196 9.73817 21.2071 9.92571C21.3946 10.1132 21.5 10.3676 21.5 10.6328V20.1328C21.5 20.398 21.3946 20.6524 21.2071 20.8399C21.0196 21.0275 20.7652 21.1328 20.5 21.1328H19.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M18 11.6328V8.63281H2.5V21.6328H18V18.6328"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M16 13.1328C15.7374 13.1328 15.4773 13.1845 15.2346 13.2851C14.992 13.3856 14.7715 13.5329 14.5858 13.7186C14.4001 13.9043 14.2528 14.1248 14.1522 14.3674C14.0517 14.6101 14 14.8702 14 15.1328C14 15.3955 14.0517 15.6555 14.1522 15.8982C14.2528 16.1408 14.4001 16.3613 14.5858 16.547C14.7715 16.7327 14.992 16.8801 15.2346 16.9806C15.4773 17.0811 15.7374 17.1328 16 17.1328H19V13.1328H16Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 11.5V18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5025 13C10.0025 12 6.39246 11.8 6.50246 13.5C6.62246 15.33 11.0025 14.035 11.0025 16C11.0025 17.35 8.00246 18 6.50246 16.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ImgSearchIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 11V18H2V4H7.02C7.07 3.29 7.24 2.62 7.5 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V13L16 11ZM14.5 16H3.5L6.25 12.47L8.21 14.83L10.96 11.29L14.5 16ZM17.3 6.89C17.74 6.19 18 5.38 18 4.5C18 2.01 15.99 0 13.5 0C11.01 0 9 2.01 9 4.5C9 6.99 11.01 9 13.49 9C14.37 9 15.19 8.74 15.88 8.3L19 11.42L20.42 10L17.3 6.89ZM13.5 7C12.12 7 11 5.88 11 4.5C11 3.12 12.12 2 13.5 2C14.88 2 16 3.12 16 4.5C16 5.88 14.88 7 13.5 7Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const ImgIcon = (props) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.7917 2.70833V17.2917H2.20833V2.70833H16.7917ZM16.7917 0.625H2.20833C1.0625 0.625 0.125 1.5625 0.125 2.70833V17.2917C0.125 18.4375 1.0625 19.375 2.20833 19.375H16.7917C17.9375 19.375 18.875 18.4375 18.875 17.2917V2.70833C18.875 1.5625 17.9375 0.625 16.7917 0.625ZM11.7292 9.85417L8.60417 13.8854L6.375 11.1875L3.25 15.2083H15.75L11.7292 9.85417Z"
        fill="#065699"
        fillOpacity="0.5"
      />
    </svg>
  );
};
export const PDFFileIcon = (props) => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8333 0.582031H6.33325C5.18742 0.582031 4.24992 1.51953 4.24992 2.66536V15.1654C4.24992 16.3112 5.18742 17.2487 6.33325 17.2487H18.8333C19.9791 17.2487 20.9166 16.3112 20.9166 15.1654V2.66536C20.9166 1.51953 19.9791 0.582031 18.8333 0.582031ZM9.97908 8.39453C9.97908 9.25911 9.28117 9.95703 8.41658 9.95703H7.37492V12.0404H5.81242V5.79036H8.41658C9.28117 5.79036 9.97908 6.48828 9.97908 7.35286V8.39453ZM15.1874 10.4779C15.1874 11.3424 14.4895 12.0404 13.6249 12.0404H11.0208V5.79036H13.6249C14.4895 5.79036 15.1874 6.48828 15.1874 7.35286V10.4779ZM19.3541 7.35286H17.7916V8.39453H19.3541V9.95703H17.7916V12.0404H16.2291V5.79036H19.3541V7.35286ZM7.37492 8.39453H8.41658V7.35286H7.37492V8.39453ZM2.16659 4.7487H0.083252V19.332C0.083252 20.4779 1.02075 21.4154 2.16659 21.4154H16.7499V19.332H2.16659V4.7487ZM12.5833 10.4779H13.6249V7.35286H12.5833V10.4779Z"
        fill="grey"
      />
    </svg>
  );
};
export const MoneyApprovedCreditcardIcon = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.625 26.375H3.125C2.66087 26.375 2.21575 26.1906 1.88756 25.8624C1.55937 25.5342 1.375 25.0891 1.375 24.625V3.625C1.375 3.16087 1.55937 2.71575 1.88756 2.38756C2.21575 2.05937 2.66087 1.875 3.125 1.875H32.875C33.3391 1.875 33.7842 2.05937 34.1124 2.38756C34.4406 2.71575 34.625 3.16087 34.625 3.625V24.625C34.625 25.0891 34.4406 25.5342 34.1124 25.8624C33.7842 26.1906 33.3391 26.375 32.875 26.375H29.375"
        stroke="#065699"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 21.125L16.25 26.375L13.625 23.75"
        stroke="#065699"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M5.75 6.25V11.5H11V6.25H5.75Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 7.125H16.25"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.75 7.125H21.5"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 7.125H26.75"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.375 10.625H26.75"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 10.625H18.875"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 34.25L23.355 31.0388C24.3909 30.4164 25.248 29.5365 25.8429 28.4846C26.4379 27.4327 26.7504 26.2447 26.75 25.0362V17.625L18 14.125L9.25 17.625V25.0362C9.24963 26.2447 9.56211 27.4327 10.1571 28.4846C10.752 29.5365 11.6091 30.4164 12.645 31.0388L18 34.25Z"
        stroke="#065699"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BusinessBuilding = (props) => {
  return (
    <svg
      width="36"
      height="22"
      viewBox="0 0 36 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.625 9.5L18 1L1.375 9.5"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M30.25 16V21H5.75V16"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M14.5 16.5H9.25V21H14.5V16.5Z"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M26.75 16.5H18V19H26.75V16.5Z"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M18 7C19.933 7 21.5 6.55228 21.5 6C21.5 5.44772 19.933 5 18 5C16.067 5 14.5 5.44772 14.5 6C14.5 6.55228 16.067 7 18 7Z"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M6.625 9.5V7"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M29.375 9.5V7"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M6.625 9.5L4 12.5H32L29.375 9.5H6.625Z"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11 12.5L12.75 9.5"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M23.25 9.5L25 12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M18 9.5V12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M4 12.5V13C4 13.5304 4.36875 14.0391 5.02513 14.4142C5.6815 14.7893 6.57174 15 7.5 15C8.42826 15 9.3185 14.7893 9.97487 14.4142C10.6313 14.0391 11 13.5304 11 13V12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11 12.5V13C11 13.5304 11.3687 14.0391 12.0251 14.4142C12.6815 14.7893 13.5717 15 14.5 15C15.4283 15 16.3185 14.7893 16.9749 14.4142C17.6313 14.0391 18 13.5304 18 13V12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M18 12.5V13C18 13.5304 18.3687 14.0391 19.0251 14.4142C19.6815 14.7893 20.5717 15 21.5 15C22.4283 15 23.3185 14.7893 23.9749 14.4142C24.6313 14.0391 25 13.5304 25 13V12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M25 12.5V13C25 13.5304 25.3687 14.0391 26.0251 14.4142C26.6815 14.7893 27.5717 15 28.5 15C29.4283 15 30.3185 14.7893 30.9749 14.4142C31.6313 14.0391 32 13.5304 32 13V12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const HouseSearch = (props) => {
  return (
    <svg
      width="44"
      height="41"
      viewBox="0 0 44 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 36C25.3137 36 28 33.3137 28 30C28 26.6863 25.3137 24 22 24C18.6863 24 16 26.6863 16 30C16 33.3137 18.6863 36 22 36Z"
        stroke="#065699"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M17.65 34.3516L12 40.0016"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 17V30H11"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33 30V12L22 1L11 12V30"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 14C19 13.2044 19.3161 12.4413 19.8787 11.8787C20.4413 11.3161 21.2044 11 22 11C22.7956 11 23.5587 11.3161 24.1213 11.8787C24.6839 12.4413 25 13.2044 25 14"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 21V18H25V21"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 16L4 7H16"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 16H1"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28 7H40L43 16H34"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M40 17V30H33"
        stroke="#065699"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Info = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0.5C4.48 0.5 0 4.98 0 10.5C0 16.02 4.48 20.5 10 20.5C15.52 20.5 20 16.02 20 10.5C20 4.98 15.52 0.5 10 0.5ZM11 15.5H9V13.5H11V15.5ZM11 11.5H9V5.5H11V11.5Z"
        fill="#0288D1"
      />
    </svg>
  );
};
export const CreateNewFolderIcon = (props) => {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 2.5H10L8 0.5H2C0.89 0.5 0.00999999 1.39 0.00999999 2.5L0 14.5C0 15.61 0.89 16.5 2 16.5H18C19.11 16.5 20 15.61 20 14.5V4.5C20 3.39 19.11 2.5 18 2.5ZM17 10.5H14V13.5H12V10.5H9V8.5H12V5.5H14V8.5H17V10.5Z"
        fill="white"
      />
    </svg>
  );
};
export const LoaderSvg = () => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      class="inline mr-3 w-4 h-4 text-white animate-spin"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
export const RoundInfo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM13 17.5H11V15.5H13V17.5ZM13 13.5H11V7.5H13V13.5Z"
        fill="#0288D1"
      />
    </svg>
  );
};
export const SalesUSer = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 5.00063C10.2885 4.65871 11.1407 4.48828 12 4.50063C12.8593 4.48828 13.7115 4.65871 14.5 5.00063"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 7V5.5C16 4 16 2.5 12 2.5C8 2.5 8 4 8 5.5V7"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="10.5" cy="9" r="0.5" fill="black" fillOpacity="0.54" />
      <circle cx="13.5" cy="9" r="0.5" fill="black" fillOpacity="0.54" />
      <path
        d="M12 16C11.4067 16 10.8266 16.1759 10.3333 16.5056C9.83994 16.8352 9.45543 17.3038 9.22836 17.8519C9.0013 18.4001 8.94189 19.0033 9.05765 19.5853C9.1734 20.1672 9.45912 20.7018 9.87868 21.1213C10.2982 21.5409 10.8328 21.8266 11.4147 21.9424C11.9967 22.0581 12.5999 21.9987 13.1481 21.7716C13.6962 21.5446 14.1648 21.1601 14.4944 20.6667C14.8241 20.1734 15 19.5933 15 19C15 18.2044 14.6839 17.4413 14.1213 16.8787C13.5587 16.3161 12.7957 16 12 16Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 18.4922L11.5 19.4922L13 17.9922"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M2.5 19.5V17.56C2.49922 17.116 2.64621 16.6844 2.91779 16.3331C3.18937 15.9819 3.57011 15.731 4 15.62L8.5 14.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.5 19.5V17.56C21.5008 17.116 21.3538 16.6844 21.0822 16.3331C20.8106 15.9819 20.4299 15.731 20 15.62L15.5 14.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 9C7.5 9.32082 7.59496 9.63445 7.77292 9.90139C7.95087 10.1683 8.20386 10.3766 8.5 10.5V11C8.5 12.655 10.345 14 12 14C13.655 14 15.5 12.655 15.5 11V10.5C15.7961 10.3766 16.0491 10.1683 16.2271 9.90139C16.405 9.63445 16.5 9.32082 16.5 9"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Contract = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 8.5V3C16.5 2.86739 16.4473 2.74021 16.3536 2.64645C16.2598 2.55268 16.1326 2.5 16 2.5H3C2.86739 2.5 2.74021 2.55268 2.64645 2.64645C2.55268 2.74021 2.5 2.86739 2.5 3V21C2.5 21.1326 2.55268 21.2598 2.64645 21.3536C2.74021 21.4473 2.86739 21.5 3 21.5H16C16.1326 21.5 16.2598 21.4473 16.3536 21.3536C16.4473 21.2598 16.5 21.1326 16.5 21V19.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 10C16.7089 10 15.9355 10.2346 15.2777 10.6741C14.6199 11.1136 14.1072 11.7384 13.8045 12.4693C13.5017 13.2002 13.4225 14.0044 13.5769 14.7804C13.7312 15.5563 14.1122 16.269 14.6716 16.8284C15.231 17.3878 15.9437 17.7688 16.7196 17.9231C17.4956 18.0775 18.2998 17.9983 19.0307 17.6955C19.7616 17.3928 20.3864 16.8801 20.8259 16.2223C21.2654 15.5645 21.5 14.7911 21.5 14C21.5 12.9391 21.0786 11.9217 20.3284 11.1716C19.5783 10.4214 18.5609 10 17.5 10Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 6H14"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 8H14"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 10H14"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 12H14"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 14H13.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M15.5 13.5L17 15L19.5 12.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5 18.5C5 18.5 5.38 16 7 16C8.355 16 7.63 18.41 7.63 18.41C7.63 18.41 8.13 16.1 9.63 16.36C10.795 16.555 10.16 18.435 10.16 18.435C10.16 18.435 10.855 16.935 12.08 16.435"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const GeneralDetail = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 18V4L10 0L0 4V18H5V9H15V18H20ZM9 16H7V18H9V16ZM11 13H9V15H11V13ZM13 16H11V18H13V16Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const UserIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.0026 7.00065C8.84427 7.00065 10.3359 5.50898 10.3359 3.66732C10.3359 1.82565 8.84427 0.333984 7.0026 0.333984C5.16094 0.333984 3.66927 1.82565 3.66927 3.66732C3.66927 5.50898 5.16094 7.00065 7.0026 7.00065ZM7.0026 8.66732C4.7776 8.66732 0.335938 9.78398 0.335938 12.0007V13.6673H13.6693V12.0007C13.6693 9.78398 9.2276 8.66732 7.0026 8.66732Z"
        fill="white"
      />
    </svg>
  );
};

export const UserIconB = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.0026 7.00065C8.84427 7.00065 10.3359 5.50898 10.3359 3.66732C10.3359 1.82565 8.84427 0.333984 7.0026 0.333984C5.16094 0.333984 3.66927 1.82565 3.66927 3.66732C3.66927 5.50898 5.16094 7.00065 7.0026 7.00065ZM7.0026 8.66732C4.7776 8.66732 0.335938 9.78398 0.335938 12.0007V13.6673H13.6693V12.0007C13.6693 9.78398 9.2276 8.66732 7.0026 8.66732Z"
        fill="rgba(0, 0, 0, 0.54)"
      />
    </svg>
  );
};

export const PDF = () => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0023 5.85325V34.2769C27.0023 34.9505 26.4538 35.5 25.7814 35.5H3.27553C2.60318 35.5 2.05469 34.9505 2.05469 34.2769V1.72309C2.05469 1.04951 2.60318 0.5 3.27553 0.5H21.65L27.0023 5.85325Z"
        fill="white"
      />
      <path
        d="M27.0002 5.85325V34.2769C27.0002 34.9505 26.4517 35.5 25.7794 35.5H24.0366C24.7089 35.5 25.2574 34.9505 25.2574 34.2769V5.85325L19.9141 0.5H21.6569L27.0002 5.85325Z"
        fill="#E5E5E5"
      />
      <path
        d="M27.0007 5.85325H22.8693C22.1969 5.85325 21.6484 5.30375 21.6484 4.63016V0.5L27.0007 5.85325Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 17.0773H7.35342C6.86685 17.0773 6.46875 16.6785 6.46875 16.191C6.46875 15.7035 6.86685 15.3047 7.35342 15.3047H21.8442C22.3308 15.3047 22.7289 15.7035 22.7289 16.191C22.7289 16.6873 22.3397 17.0773 21.8442 17.0773Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 21.6242H7.35342C6.86685 21.6242 6.46875 21.2253 6.46875 20.7379C6.46875 20.2504 6.86685 19.8516 7.35342 19.8516H21.8442C22.3308 19.8516 22.7289 20.2504 22.7289 20.7379C22.7289 21.2342 22.3397 21.6242 21.8442 21.6242Z"
        fill="#CECECE"
      />
      <path
        d="M21.8442 26.171H7.35342C6.86685 26.171 6.46875 25.7722 6.46875 25.2847C6.46875 24.7973 6.86685 24.3984 7.35342 24.3984H21.8442C22.3308 24.3984 22.7289 24.7973 22.7289 25.2847C22.7289 25.7811 22.3397 26.171 21.8442 26.171Z"
        fill="#CECECE"
      />
      <path
        d="M12.2526 12.4671H0V7.49495C0 7.1227 0.300782 6.8125 0.681188 6.8125H12.2526C12.6242 6.8125 12.9338 7.11384 12.9338 7.49495V11.7846C12.9338 12.1569 12.633 12.4671 12.2526 12.4671Z"
        fill="#F55B4B"
      />
      <path
        d="M12.9338 11.696V11.7846C12.9338 12.1569 12.633 12.4671 12.2526 12.4671H0V7.49495C0 7.1227 0.300782 6.8125 0.681188 6.8125H1.02621V8.5851C1.02621 10.3045 2.41514 11.7049 4.14023 11.7049H12.9338V11.696Z"
        fill="#DD4E43"
      />
      <path d="M0 12.4688L2.05242 14.8086V12.4688H0Z" fill="#DB1B1B" />
      <path
        d="M3.3177 10.7139V11.3077H1.46875V10.7139H1.91993V8.38288H1.46875V7.78906H3.3177C3.75119 7.78906 4.07852 7.88655 4.31738 8.0904C4.55624 8.29425 4.67124 8.56901 4.67124 8.9058C4.67124 9.10079 4.62701 9.27805 4.54739 9.43758C4.46777 9.59712 4.36161 9.7212 4.22891 9.80096C4.09621 9.88959 3.95466 9.94277 3.78658 9.97822C3.61849 10.0137 3.41502 10.0225 3.16731 10.0225H2.83114V10.705H3.3177V10.7139ZM2.83114 9.43758H2.96384C3.27347 9.43758 3.47694 9.3844 3.56541 9.28691C3.65388 9.18942 3.69811 9.05647 3.69811 8.9058C3.69811 8.78172 3.66272 8.6665 3.60079 8.57787C3.53887 8.48924 3.4681 8.43606 3.38848 8.40947C3.30886 8.39175 3.17616 8.37402 2.99038 8.37402H2.82229V9.43758H2.83114Z"
        fill="white"
      />
      <path
        d="M4.88281 11.3077V10.7139H5.41361V8.38288H4.88281V7.78906H6.54599C6.89986 7.78906 7.1741 7.80679 7.39527 7.8511C7.60759 7.89542 7.81106 7.99291 8.00569 8.13472C8.20031 8.28539 8.35955 8.48038 8.47456 8.72854C8.58957 8.97671 8.65149 9.25146 8.65149 9.5528C8.65149 9.80096 8.60726 10.0314 8.52764 10.253C8.44802 10.4746 8.34186 10.6518 8.218 10.7936C8.09415 10.9266 7.9526 11.0418 7.77567 11.1216C7.60758 11.2013 7.44835 11.2545 7.3068 11.2811C7.16525 11.3077 6.94409 11.3165 6.6433 11.3165H4.88281V11.3077ZM6.33367 10.7139H6.55483C6.82023 10.7139 7.03255 10.6784 7.19179 10.6075C7.35103 10.5366 7.47489 10.4125 7.56335 10.2441C7.66067 10.0669 7.7049 9.84528 7.7049 9.56166C7.7049 9.29577 7.66067 9.06534 7.56335 8.87921C7.46604 8.69309 7.34219 8.56014 7.1741 8.48924C7.01486 8.41834 6.80254 8.38288 6.55483 8.38288H6.33367V10.7139Z"
        fill="white"
      />
      <path
        d="M9.0625 11.3077V10.7139H9.56676V8.38288H9.0625V7.78906H12.2119V8.87921H11.5396V8.39175H10.4868V9.20714H11.2476V9.80096H10.4868V10.7139H11.0265V11.3077H9.0625Z"
        fill="white"
      />
      <path
        d="M10.9092 14.1173H2.0625V12.4688H12.2981V12.7346C12.2892 13.4969 11.67 14.1173 10.9092 14.1173Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};
export const Undo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <g opacity="0.6">
        <path
          d="M10.4 9.4C8.7 9.7 7.2 10.3 5.8 11.4L3 8.5V15.5H10L7.3 12.8C11 10.2 16.1 11 18.8 14.7C19 15 19.2 15.2 19.3 15.5L21.1 14.6C18.9 10.8 14.7 8.7 10.4 9.4Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export const Redo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <g opacity="0.6">
        <path
          d="M13.6 9.4C15.3 9.7 16.8 10.3 18.2 11.4L21 8.5V15.5H14L16.7 12.8C13 10.1 7.9 11 5.3 14.7C5.1 15 4.9 15.2 4.8 15.5L3 14.6C5.1 10.8 9.3 8.7 13.6 9.4Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export const Bold = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M15.2484 11.8C15.7381 11.5018 16.1513 11.0934 16.4551 10.6073C16.7589 10.1212 16.945 9.57077 16.9984 9C17.0077 8.48388 16.9152 7.971 16.7262 7.49063C16.5373 7.01027 16.2555 6.57184 15.8971 6.20039C15.5386 5.82894 15.1105 5.53174 14.6372 5.32578C14.1638 5.11981 13.6546 5.00911 13.1384 5H6.64844V19H13.6484C14.1396 18.9948 14.6249 18.8929 15.0767 18.7001C15.5284 18.5073 15.9378 18.2274 16.2814 17.8764C16.6249 17.5253 16.896 17.1101 17.0791 16.6543C17.2622 16.1985 17.3537 15.7112 17.3484 15.22V15.1C17.3488 14.4071 17.1514 13.7285 16.7794 13.144C16.4074 12.5594 15.8763 12.0931 15.2484 11.8ZM8.64844 7H12.8484C13.2746 6.98681 13.6946 7.10428 14.0521 7.33665C14.4096 7.56902 14.6875 7.90517 14.8484 8.3C15.0113 8.82779 14.9586 9.39859 14.7019 9.88765C14.4452 10.3767 14.0053 10.7443 13.4784 10.91C13.2738 10.97 13.0617 11.0003 12.8484 11H8.64844V7ZM13.2484 17H8.64844V13H13.2484C13.6746 12.9868 14.0946 13.1043 14.4521 13.3367C14.8096 13.569 15.0875 13.9052 15.2484 14.3C15.4113 14.8278 15.3586 15.3986 15.1019 15.8877C14.8452 16.3767 14.4053 16.7443 13.8784 16.91C13.6738 16.97 13.4617 17.0003 13.2484 17Z"
        fill="black"
      />
    </svg>
  );
};
export const Underline = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M19 20V22H5V20H19ZM16 13.215C15.9671 13.875 15.7711 14.5165 15.4297 15.0823C15.0883 15.6481 14.6121 16.1205 14.0435 16.4572C13.475 16.794 12.8318 16.9847 12.1716 17.0122C11.5114 17.0397 10.8546 16.9033 10.26 16.615C9.57464 16.3185 8.99341 15.8241 8.59077 15.1952C8.18813 14.5663 7.98242 13.8315 8 13.085V5.005H6V13.215C6.03383 14.1564 6.28885 15.0766 6.74442 15.9012C7.19998 16.7257 7.84329 17.4314 8.62227 17.9611C9.40125 18.4908 10.294 18.8296 11.2283 18.9502C12.1625 19.0707 13.1121 18.9696 14 18.655C15.1811 18.2613 16.2059 17.5012 16.9252 16.485C17.6446 15.4689 18.0211 14.2498 18 13.005V5.005H16V13.215ZM16 5H18H16ZM8 5H6H8Z"
        fill="black"
      />
    </svg>
  );
};
export const Link = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <path
        d="M11 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7H11V9H7C6.20435 9 5.44129 9.31607 4.87868 9.87868C4.31607 10.4413 4 11.2044 4 12C4 12.7956 4.31607 13.5587 4.87868 14.1213C5.44129 14.6839 6.20435 15 7 15H11V17ZM17 7H13V9H17C17.7956 9 18.5587 9.31607 19.1213 9.87868C19.6839 10.4413 20 11.2044 20 12C20 12.7956 19.6839 13.5587 19.1213 14.1213C18.5587 14.6839 17.7956 15 17 15H13V17H17C18.3261 17 19.5979 16.4732 20.5355 15.5355C21.4732 14.5979 22 13.3261 22 12C22 10.6739 21.4732 9.40215 20.5355 8.46447C19.5979 7.52678 18.3261 7 17 7ZM16 11H8V13H16V11Z"
        fill="black"
      />
    </svg>
  );
};
export const Upload = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hover:bg-lightThemeSecondary"
    >
      <rect width="24" height="24" rx="4" fillOpacity="0.3" />
      <path
        d="M14.2 11L18 16H6L9 12.1L11.1 14.8L14 11H14.2ZM8.5 11C9.3 11 10 10.3 10 9.5C10 8.7 9.3 8 8.5 8C7.7 8 7 8.7 7 9.5C7 10.3 7.7 11 8.5 11ZM22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6ZM20 8.8V6H4V18H20V8.8Z"
        fill="black"
      />
    </svg>
  );
};
export const More = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ddd_6454_54447)">
        <rect
          x="14"
          y="13"
          width="24"
          height="24"
          rx="8"
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          d="M26 21C27.1 21 28 20.1 28 19C28 17.9 27.1 17 26 17C24.9 17 24 17.9 24 19C24 20.1 24.9 21 26 21ZM26 23C24.9 23 24 23.9 24 25C24 26.1 24.9 27 26 27C27.1 27 28 26.1 28 25C28 23.9 27.1 23 26 23ZM26 29C24.9 29 24 29.9 24 31C24 32.1 24.9 33 26 33C27.1 33 28 32.1 28 31C28 29.9 27.1 29 26 29Z"
          fill="black"
          fillOpacity="0.54"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_6454_54447"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6454_54447"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_6454_54447"
            result="effect2_dropShadow_6454_54447"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_6454_54447"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_6454_54447"
            result="effect3_dropShadow_6454_54447"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_6454_54447"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const LogoB = () => {
  return (
    <svg
      width="86"
      height="76"
      viewBox="0 0 86 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7231_75452)">
        <path
          d="M27.2674 11.6943C27.2674 12.1192 27.0925 12.3561 26.7401 12.4051C26.6912 12.4133 19.8132 12.416 19.7592 12.416C19.7026 12.416 19.3477 12.4623 18.6918 12.5494C18.0359 12.642 17.3388 12.8817 16.6006 13.2738C15.8624 13.666 15.1782 14.2978 14.5531 15.172C13.9281 16.0462 13.6143 17.2962 13.6143 18.922V35.0033H26.5755C27.0308 35.0033 27.2597 35.2157 27.2597 35.6351C27.2597 36.1199 27.0308 36.3595 26.5755 36.3595H13.6143V63.1843C13.6143 63.6691 13.4162 63.9087 13.0176 63.9087C12.5623 63.9087 12.3359 63.6691 12.3359 63.1843V18.9248C12.3359 16.9966 12.7192 15.507 13.4857 14.453C14.2548 13.3991 15.0959 12.6175 16.0039 12.1028C16.9144 11.5908 18.1696 11.245 19.7592 11.0625C19.8132 11.0625 26.6887 11.0625 26.735 11.0707C27.0925 11.1142 27.27 11.3239 27.27 11.6943H27.2674Z"
          fill="#231F20"
        />
        <path
          d="M13.0122 65.4753C11.739 65.4753 10.8516 64.5331 10.8516 63.1877V18.9254C10.8516 16.6542 11.3403 14.8296 12.3074 13.4978C13.2025 12.2724 14.2082 11.3382 15.3014 10.7228C16.3946 10.11 17.799 9.71242 19.5944 9.50817L19.7513 9.5C26.7553 9.5 26.8042 9.50545 26.9096 9.52179C27.9951 9.65251 28.7384 10.5267 28.7384 11.6977C28.7384 12.8688 28.0131 13.8029 26.9328 13.9608C26.8248 13.9772 26.7579 13.9853 19.8027 13.9853C19.6715 13.9989 19.3629 14.0398 18.8742 14.1079C18.388 14.176 17.8427 14.3693 17.2537 14.6798C16.7238 14.9603 16.2068 15.4478 15.7207 16.1231C15.2988 16.7141 15.0828 17.6564 15.0828 18.9254V33.4408H26.5675C27.8408 33.4408 28.7282 34.3449 28.7282 35.6385C28.7282 36.9321 27.8382 37.9261 26.5675 37.9261H15.0828V63.185C15.0828 64.5331 14.2288 65.4726 13.0096 65.4726L13.0122 65.4753Z"
          fill="#231F20"
        />
        <path
          d="M71.2967 11.1484C71.752 11.1484 71.9809 11.3609 71.9809 11.783V28.5859C71.8677 29.6099 71.6671 30.574 71.3842 31.4781C71.0986 32.2624 70.6717 33.0604 70.1032 33.8719C69.5348 34.6862 68.7374 35.3343 67.7162 35.8136C68.74 36.2957 69.7045 37.08 70.6177 38.1639C71.5282 39.2478 71.9835 40.8464 71.9835 42.9542V63.273C71.9835 63.755 71.7546 63.9947 71.2993 63.9947C70.844 63.9947 70.6177 63.755 70.6177 63.273V42.9542C70.6177 41.3284 70.3039 40.0784 69.6788 39.2042C69.0538 38.3327 68.3696 37.6982 67.6314 37.306C66.8906 36.9139 66.1935 36.6742 65.5402 36.5843C64.8869 36.4945 64.5293 36.4482 64.4727 36.4482H58.3278V63.2757C58.3278 63.7577 58.1272 63.9974 57.7285 63.9974C57.2732 63.9974 57.0469 63.7577 57.0469 63.2757V11.783C57.0469 11.3609 57.2732 11.1484 57.7285 11.1484C58.1272 11.1484 58.3278 11.3609 58.3278 11.783V35.0947H64.4727C66.0083 35.0947 67.189 34.7652 68.0146 34.1007C68.8377 33.4389 69.437 32.7145 69.8074 31.9302C70.1778 31.1486 70.4042 30.4106 70.4916 29.7161C70.5765 29.0244 70.6177 28.6458 70.6177 28.5859V11.783C70.6177 11.3609 70.8466 11.1484 71.2993 11.1484H71.2967Z"
          fill="#231F20"
        />
        <path
          d="M71.2965 65.5613C70.0232 65.5613 69.1358 64.6217 69.1358 63.2764V42.9576C69.1358 41.6886 68.9198 40.7463 68.4954 40.1499C68.0118 39.4772 67.4974 38.9897 66.9624 38.7065C66.3759 38.3961 65.828 38.2027 65.3419 38.1373C64.8558 38.0693 64.5445 38.0284 64.4108 38.0148H59.7989V63.2764C59.7989 64.6217 58.9449 65.5613 57.7231 65.5613C56.5013 65.5613 55.5625 64.6217 55.5625 63.2764V11.7837C55.5625 10.4901 56.4499 9.58594 57.7231 9.58594C58.9963 9.58594 59.7989 10.4901 59.7989 11.7837V33.5295H64.4648C65.6634 33.5295 66.556 33.3034 67.1116 32.8541C67.752 32.3394 68.2099 31.792 68.4774 31.231C68.7706 30.6128 68.9532 30.0354 69.0175 29.5125C69.0793 29.0006 69.1178 28.671 69.1307 28.5322V11.7837C69.1307 10.4901 70.0181 9.58594 71.2913 9.58594C72.5646 9.58594 73.452 10.4901 73.452 11.7837L73.4417 28.7691C73.3182 29.8884 73.0944 30.9641 72.778 31.9717C72.4205 32.9576 71.9241 33.8862 71.281 34.8067C71.0315 35.1662 70.746 35.4984 70.4271 35.8062C70.8695 36.1956 71.2965 36.6341 71.708 37.127C72.8629 38.5023 73.4494 40.4658 73.4494 42.9576V63.2764C73.4494 64.6217 72.5594 65.5613 71.2888 65.5613H71.2965Z"
          fill="#231F20"
        />
        <path
          d="M48.6827 32.468C48.9682 31.8062 49.1843 31.188 49.3257 30.6161C49.4646 30.0442 49.5649 29.3661 49.6241 28.5818V19.0066C49.4543 17.3208 49.1251 15.9809 48.6415 14.9842C48.1605 13.9902 47.4069 13.086 46.3806 12.2718C45.4726 11.5528 44.238 11.1715 42.7127 11.0871C42.6355 11.0762 42.5764 11.0599 42.4966 11.0517C42.4297 11.0517 35.3357 11.0408 35.2842 11.0517C34.8856 11.1743 34.6875 11.4139 34.6875 11.7761V63.2607C34.6875 63.6229 34.8856 63.8653 35.2842 63.9851C35.3305 63.9933 42.4889 63.9851 42.4966 63.9851C42.6098 63.9742 42.705 63.9497 42.8053 63.9334C44.6907 63.7972 46.2366 63.1436 47.4043 61.9099C47.9702 61.3081 48.3972 60.6763 48.6801 60.0118C48.9656 59.35 49.1817 58.7318 49.3232 58.1599C49.4621 57.588 49.5624 56.9099 49.6215 56.1256V42.9474C49.6215 40.8395 49.1637 39.2409 48.2531 38.157C47.3452 37.0731 46.378 36.2915 45.3543 35.8068C46.1491 35.4446 46.8333 34.9653 47.4043 34.3607C47.9702 33.7589 48.3972 33.127 48.6801 32.4625L48.6827 32.468ZM47.3169 39.2001C47.9419 40.0743 48.2557 41.3243 48.2557 42.9501V56.1283C48.2557 56.6702 48.1708 57.2449 48.0011 57.8467C47.8879 58.3315 47.7156 58.8407 47.4866 59.3827C47.2603 59.9246 46.9182 60.4393 46.4629 60.9186C45.3826 62.0624 43.9319 62.6343 42.1134 62.6343C42.1082 62.6343 37.1722 62.5363 35.971 62.5254V36.4413H42.1134C42.1674 36.4413 42.5249 36.4876 43.1808 36.5775C43.8341 36.6674 44.5312 36.9097 45.2694 37.2992C46.0102 37.6913 46.6944 38.3232 47.3194 39.1973L47.3169 39.2001ZM42.1108 34.998H35.9684V12.5141C37.1336 12.5005 39.9013 12.5114 41.3983 12.5114C41.3983 12.5223 42.1777 12.5114 42.2574 12.5114C43.7184 12.5332 44.8553 12.8573 45.6552 13.4973C46.4783 14.159 47.0751 14.8834 47.4455 15.6678C47.8133 16.4494 48.0422 17.1874 48.1297 17.8818C48.2146 18.5736 48.2557 18.9521 48.2557 19.012V28.5872C48.2557 29.1292 48.1708 29.7038 48.0011 30.3057C47.8879 30.7877 47.7156 31.2997 47.4866 31.8416C47.2603 32.3836 46.9182 32.8956 46.4629 33.3776C45.4392 34.4615 43.991 35.0034 42.1134 35.0034L42.1108 34.998Z"
          fill="#231F20"
        />
        <path
          d="M37.3418 65.5595C35.1709 65.5595 35.1298 65.5513 35.0115 65.5268L34.8777 65.4941C33.8488 65.1837 33.2109 64.3285 33.2109 63.2664V11.7819C33.2109 10.7225 33.8488 9.86736 34.8751 9.55418L34.9729 9.52967C35.1083 9.4988 37.5682 9.487 42.3524 9.49426L42.6585 9.50516C42.7383 9.51333 42.8077 9.52694 42.8772 9.54056C44.6828 9.65222 46.1593 10.1533 47.2653 11.0275C48.4691 11.9834 49.3719 13.0754 49.9558 14.2764C50.5294 15.4584 50.9023 16.9535 51.0927 18.8462L51.1004 19.0123L51.0952 28.7128C51.0284 29.5843 50.9152 30.3577 50.7531 31.014C50.5911 31.6676 50.3545 32.3539 50.0278 33.1192C49.6728 33.9471 49.143 34.7395 48.4536 35.4748C48.3405 35.5947 48.2221 35.7118 48.1012 35.8234C48.5359 36.2074 48.9552 36.6432 49.3616 37.1252C50.5165 38.5005 51.103 40.464 51.103 42.9558L51.0978 56.2593C51.0309 57.1308 50.9178 57.9042 50.7557 58.5605C50.5937 59.2168 50.357 59.9058 50.0278 60.6684C49.6754 61.4935 49.1455 62.286 48.4536 63.0213C47.0647 64.4892 45.2256 65.3171 42.9826 65.4968C42.8412 65.5241 42.7486 65.5377 42.6457 65.5486L42.4991 65.5568C40.0581 65.5595 38.4324 65.5622 37.3444 65.5622L37.3418 65.5595ZM37.4473 60.9816C40.2947 61.0088 41.5216 61.036 42.1132 61.085V61.0769C43.5382 61.0769 44.6211 60.6656 45.4185 59.8187C45.7451 59.4728 45.9869 59.1161 46.1361 58.7566C46.3316 58.2963 46.4756 57.8661 46.5682 57.4712C46.7148 56.951 46.7791 56.5262 46.7791 56.134V42.9558C46.7791 41.684 46.5657 40.7418 46.1412 40.1508C45.6577 39.4754 45.1432 38.9907 44.6082 38.7074C44.0218 38.397 43.4765 38.2036 42.9903 38.1383C42.5042 38.0702 42.193 38.0293 42.0592 38.0157H37.4499V60.9843L37.4473 60.9816ZM37.4473 33.4378H42.1132C43.5948 33.4378 44.6751 33.0538 45.4185 32.2695C45.7451 31.9236 45.9869 31.5669 46.1361 31.2101C46.3316 30.7471 46.4756 30.3196 46.5682 29.9247C46.7148 29.4073 46.7791 28.9797 46.7791 28.5875V19.0668C46.7663 18.9279 46.7277 18.5984 46.666 18.0809C46.6017 17.5717 46.419 16.9943 46.1258 16.3679C45.8583 15.8069 45.4005 15.2596 44.7626 14.7448C44.2327 14.32 43.3839 14.0967 42.2418 14.0804C41.8946 14.0831 41.6245 14.0858 41.4033 14.0776V14.0831H39.9166C39.1064 14.0831 38.2215 14.0776 37.4525 14.0804V33.4432L37.4473 33.4378Z"
          fill="#231F20"
        />
        <path
          d="M9.60734 75.2213C8.74566 75.2213 8.1875 74.6304 8.1875 73.7153C8.1875 72.8548 8.74566 72.3019 9.60734 72.3019H76.597C77.9603 72.3019 79.002 72.0214 79.6939 71.4659C80.4218 70.8803 80.9517 70.2431 81.2706 69.5704C81.5999 68.8732 81.8056 68.2115 81.8802 67.6042C81.9548 66.9969 81.996 66.6428 82.0037 66.5448C82.0037 66.5039 82.0037 59.2272 82.014 59.1155C82.1169 58.3149 82.657 57.8438 83.4235 57.8438C84.19 57.8438 84.6608 58.3258 84.7482 59.1019C84.7534 59.1428 84.7611 59.2027 84.7611 66.5775L84.7559 66.6619C84.5759 68.4402 84.2183 69.8754 83.6936 70.9212C83.1637 71.9778 82.3484 72.9582 81.2732 73.8379C80.1492 74.7556 78.575 75.2213 76.597 75.2213H9.60734Z"
          fill="#F15B29"
        />
        <path
          d="M83.4274 58.6257C83.7772 58.6257 83.9753 58.8136 84.0164 59.1921C84.0216 59.2384 84.0241 66.5206 84.0241 66.5778C83.8544 68.2636 83.5251 69.5898 83.0441 70.5539C82.5606 71.5179 81.8198 72.4057 80.8243 73.22C79.8289 74.0316 78.4194 74.4401 76.6008 74.4401H9.61118C9.1559 74.4401 8.92955 74.1977 8.92955 73.7184C8.92955 73.2963 9.1559 73.0866 9.61118 73.0866H76.6008C78.1364 73.0866 79.317 72.7571 80.1427 72.0926C80.9658 71.4308 81.5626 70.7091 81.9329 69.9248C82.3033 69.1432 82.5297 68.4024 82.6146 67.7107C82.6995 67.019 82.7432 66.6432 82.7432 66.5833C82.7432 66.5233 82.7483 59.2412 82.7509 59.1894C82.7998 58.8163 83.0236 58.6311 83.4248 58.6311M83.4274 57.0625C82.2982 57.0625 81.4391 57.8278 81.2899 58.9688L81.2848 59.007V59.0451C81.2668 59.2058 81.2668 65.1671 81.2668 66.5179C81.2539 66.6568 81.2153 66.9863 81.151 67.501C81.0867 68.0212 80.9067 68.5985 80.6134 69.2167C80.3459 69.7805 79.8881 70.3251 79.2502 70.8398C78.692 71.2892 77.7995 71.5152 76.6008 71.5152H9.61118C8.34052 71.5152 7.45312 72.4194 7.45312 73.7129C7.45312 75.0065 8.34052 76.0005 9.61118 76.0005H76.6008C78.746 76.0005 80.472 75.4804 81.7272 74.4564C82.8872 73.506 83.7695 72.4411 84.3482 71.2865C84.927 70.1345 85.3025 68.6475 85.4928 66.7439L85.5006 66.6622V66.5778C85.5006 59.1513 85.4954 59.1186 85.48 58.9933C85.3539 57.8468 84.5257 57.0625 83.4248 57.0625H83.4274Z"
          fill="#F15B29"
        />
        <path
          d="M2.5719 18.1588C1.84141 18.1588 1.33469 17.6768 1.24724 16.9006C1.24209 16.8598 1.23438 16.7999 1.23438 9.4251L1.23952 9.34068C1.41957 7.56234 1.7771 6.12987 2.30183 5.08139C2.83427 4.02474 3.64707 3.04161 4.72224 2.16198C5.84628 1.24422 7.42045 0.78125 9.39845 0.78125H76.3881C77.2523 0.78125 77.8105 1.37221 77.8105 2.28725C77.8105 3.14782 77.2523 3.70066 76.3881 3.70066H9.39845C8.0352 3.70066 6.99347 3.98116 6.30413 4.53672C5.57363 5.12224 5.04376 5.7595 4.72481 6.43216C4.39557 7.13478 4.1898 7.79655 4.11521 8.39841C4.04061 9.00571 3.99946 9.35702 3.99174 9.45778C3.99174 14.3135 3.9866 16.8326 3.97888 16.9143C3.876 17.6877 3.33841 18.1615 2.5719 18.1615V18.1588Z"
          fill="#F15B29"
        />
        <path
          d="M76.392 1.56592C76.8472 1.56592 77.0736 1.80557 77.0736 2.2876C77.0736 2.70971 76.8472 2.91941 76.392 2.91941H9.40229C7.8667 2.91941 6.68608 3.24893 5.86041 3.91343C5.03731 4.5752 4.438 5.29688 4.0676 6.0812C3.69721 6.86552 3.47086 7.60354 3.38598 8.29527C3.3011 8.98699 3.25737 9.36281 3.25737 9.42545C3.25737 9.48264 3.2548 16.7675 3.24965 16.8166C3.20078 17.1897 2.977 17.3749 2.57574 17.3749C2.22593 17.3749 2.02787 17.1869 1.98672 16.8084C1.98157 16.7621 1.979 9.47991 1.979 9.42545C2.14876 7.73971 2.478 6.41344 2.96157 5.44939C3.44514 4.48533 4.18592 3.59752 5.18135 2.78324C6.17678 1.97169 7.58634 1.56592 9.40486 1.56592H76.3945M76.392 0.00272333H9.40229C7.2571 0.00272333 5.53374 0.52288 4.27595 1.54685C3.1159 2.49457 2.23622 3.56212 1.65491 4.71681C1.07617 5.8715 0.700629 7.35844 0.507717 9.26205L0.5 9.34375V9.42817C0.5 16.8547 0.505144 16.8874 0.520577 17.0126C0.646614 18.1592 1.47485 18.9435 2.57574 18.9435C3.67663 18.9435 4.56403 18.1755 4.71322 17.0344C4.72865 16.9092 4.73637 16.8356 4.73637 9.48264C4.74923 9.34375 4.78781 9.01423 4.85212 8.49952C4.91642 7.98481 5.09647 7.40474 5.39227 6.78109C5.65721 6.22009 6.11762 5.67542 6.75552 5.16071C7.31368 4.71136 8.20366 4.48533 9.40486 4.48533H76.3945C77.6652 4.48533 78.5551 3.58118 78.5551 2.2876C78.5551 0.994016 77.6677 0 76.3945 0L76.392 0.00272333Z"
          fill="#F15B29"
        />
        <path
          d="M27.0864 24.5354C27.0864 27.2179 25.0338 29.3911 22.5002 29.3911C19.9667 29.3911 17.9141 27.2179 17.9141 24.5354C17.9141 21.8529 19.9667 19.6797 22.5002 19.6797C25.0338 19.6797 27.0864 21.8529 27.0864 24.5354Z"
          fill="#F15B29"
        />
        <path
          d="M22.4988 30.1758C19.5614 30.1758 17.1719 27.6458 17.1719 24.5385C17.1719 21.4311 19.5614 18.8984 22.4988 18.8984C25.4363 18.8984 27.8232 21.4284 27.8232 24.5385C27.8232 27.6485 25.4337 30.1758 22.4988 30.1758ZM22.4988 20.4644C20.3768 20.4644 18.6509 22.2917 18.6509 24.5385C18.6509 26.7852 20.3768 28.6126 22.4988 28.6126C24.6209 28.6126 26.3468 26.7852 26.3468 24.5385C26.3468 22.2917 24.6209 20.4644 22.4988 20.4644Z"
          fill="#F7941D"
        />
        <path
          d="M27.0864 49.7776C27.0864 52.4601 25.0338 54.6333 22.5002 54.6333C19.9667 54.6333 17.9141 52.4601 17.9141 49.7776C17.9141 47.0951 19.9667 44.9219 22.5002 44.9219C25.0338 44.9219 27.0864 47.0951 27.0864 49.7776Z"
          fill="#F15B29"
        />
        <path
          d="M22.4988 55.4179C19.5614 55.4179 17.1719 52.888 17.1719 49.7806C17.1719 46.6733 19.5614 44.1406 22.4988 44.1406C25.4363 44.1406 27.8232 46.6706 27.8232 49.7806C27.8232 52.8907 25.4337 55.4179 22.4988 55.4179ZM22.4988 45.7065C20.3768 45.7065 18.6509 47.5339 18.6509 49.7806C18.6509 52.0274 20.3768 53.8547 22.4988 53.8547C24.6209 53.8547 26.3468 52.0274 26.3468 49.7806C26.3468 47.5339 24.6209 45.7065 22.4988 45.7065Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_7231_75452">
          <rect
            width="85"
            height="76"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Sales = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 9.49219H2.5V18.9922H6.5V9.49219Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 17.4922C4.77614 17.4922 5 17.2683 5 16.9922C5 16.716 4.77614 16.4922 4.5 16.4922C4.22386 16.4922 4 16.716 4 16.9922C4 17.2683 4.22386 17.4922 4.5 17.4922Z"
        fill="black"
        fillOpacity="0.54"
      />
      <path
        d="M18.3 12.24C18.2641 12.1128 18.2678 11.9776 18.3107 11.8525C18.3535 11.7274 18.4335 11.6184 18.54 11.54C18.7033 11.3982 18.8303 11.2193 18.9103 11.0184C18.9903 10.8174 19.0211 10.6003 19 10.385C19.0028 10.0396 18.8759 9.70569 18.6445 9.44927C18.4131 9.19284 18.0939 9.03253 17.75 9H11.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 18H7.735C8.17123 18.2058 8.62462 18.3731 9.09 18.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 13.5C14.2089 13.5 13.4355 13.7346 12.7777 14.1741C12.1199 14.6136 11.6072 15.2384 11.3045 15.9693C11.0017 16.7002 10.9225 17.5044 11.0769 18.2804C11.2312 19.0563 11.6122 19.769 12.1716 20.3284C12.731 20.8878 13.4437 21.2688 14.2196 21.4231C14.9956 21.5775 15.7998 21.4983 16.5307 21.1955C17.2616 20.8928 17.8864 20.3801 18.3259 19.7223C18.7654 19.0645 19 18.2911 19 17.5C19 16.4391 18.5786 15.4217 17.8284 14.6716C17.0783 13.9214 16.0609 13.5 15 13.5Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M13 17L14.5 18.5L17 16"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M11.7859 7V4.5C11.7859 3.83696 11.5225 3.20107 11.0537 2.73223C10.5849 2.26339 9.94898 2 9.28594 2V6.5L8.30094 9.095C8.13093 9.5513 8.00045 10.0214 7.91094 10.5H6.58594"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const RevenueIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5H2.5V3.5H21.5V7.5H19"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M19 3.5V19.5C19 19.7652 18.8946 20.0196 18.7071 20.2071C18.5196 20.3946 18.2652 20.5 18 20.5H6C5.73478 20.5 5.48043 20.3946 5.29289 20.2071C5.10536 20.0196 5 19.7652 5 19.5V3.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M12 14.5C14.2091 14.5 16 12.933 16 11C16 9.067 14.2091 7.5 12 7.5C9.79086 7.5 8 9.067 8 11C8 12.933 9.79086 14.5 12 14.5Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 12.5C13.3284 12.5 14 11.8284 14 11C14 10.1716 13.3284 9.5 12.5 9.5C11.6716 9.5 11 10.1716 11 11C11 11.8284 11.6716 12.5 12.5 12.5Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="1.94"
        stroke-linejoin="round"
      />
      <path
        d="M9.35156 8.10156C9.8496 8.39858 10.2627 8.81891 10.551 9.32202C10.8394 9.82512 10.9932 10.394 10.9978 10.9739C11.0023 11.5538 10.8573 12.125 10.5769 12.6325C10.2964 13.1401 9.8899 13.5668 9.39656 13.8716"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M15 18.5C15 17.9696 15.2107 17.4609 15.5858 17.0858C15.9609 16.7107 16.4696 16.5 17 16.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 16.5C7.53043 16.5 8.03914 16.7107 8.41421 17.0858C8.78929 17.4609 9 17.9696 9 18.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Invoice = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4L14.5 2L12 4L9.5 2L7 4L4.5 2V22L7 20L9.5 22L12 20L14.5 22L17 20L19.5 22V2L17 4Z"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 7.5H15.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 13.5H14"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M15 13.5H18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 9.5H18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 11.5H18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 15.5H18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 7.5H18"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M8 9.5V14.5"
        stroke="black"
        stroke-opacity="0.54"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DropUp = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.66406 14L12.6641 9L17.6641 14H7.66406Z" fill="#54CEB8" />
    </svg>
  );
};
export const DropDwn = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="#F6A78D" />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8.46 11.88L9.87 10.47L12 12.59L14.12 10.47L15.53 11.88L13.41 14L15.53 16.12L14.12 17.53L12 15.41L9.88 17.53L8.47 16.12L10.59 14L8.46 11.88ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const Duplicate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM19.5 21H8.5V7H19.5V21Z"
        fill="#F15B29"
      />
    </svg>
  );
};
export const MyProfile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export const LogOut = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};

export const Cancel = () => {
  return (
    <svg
      height="14"
      width="14"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
      class="css-tj5bde-Svg"
    >
      <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
    </svg>
  );
};
export const CancelIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
export const Bell = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.89 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.36 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.63 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
export const CameraIcon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_14651_86557)">
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          fill="white"
        />
        <path
          d="M3 20C3 10.0589 11.0589 2 21 2C30.9411 2 39 10.0589 39 20C39 29.9411 30.9411 38 21 38C11.0589 38 3 29.9411 3 20Z"
          stroke="#E0E0E0"
        />
        <path
          d="M22.7641 13.3346L24.2891 15.0013H27.6641V25.0013H14.3307V15.0013H17.7057L19.2307 13.3346H22.7641ZM23.4974 11.668H18.4974L16.9724 13.3346H14.3307C13.4141 13.3346 12.6641 14.0846 12.6641 15.0013V25.0013C12.6641 25.918 13.4141 26.668 14.3307 26.668H27.6641C28.5807 26.668 29.3307 25.918 29.3307 25.0013V15.0013C29.3307 14.0846 28.5807 13.3346 27.6641 13.3346H25.0224L23.4974 11.668ZM20.9974 17.5013C22.3724 17.5013 23.4974 18.6263 23.4974 20.0013C23.4974 21.3763 22.3724 22.5013 20.9974 22.5013C19.6224 22.5013 18.4974 21.3763 18.4974 20.0013C18.4974 18.6263 19.6224 17.5013 20.9974 17.5013ZM20.9974 15.8346C18.6974 15.8346 16.8307 17.7013 16.8307 20.0013C16.8307 22.3013 18.6974 24.168 20.9974 24.168C23.2974 24.168 25.1641 22.3013 25.1641 20.0013C25.1641 17.7013 23.2974 15.8346 20.9974 15.8346Z"
          fill="black"
          fill-opacity="0.54"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_14651_86557"
          x="0.5"
          y="0.5"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14651_86557"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_14651_86557"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ExportIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#F15B29" />
    </svg>
  );
};

export const CartIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 10H11V8H13V10ZM13 6H11V1H13V6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18ZM8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L21 4.96L19.25 4L15.55 11H8.53L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};

export const FileterIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.625 3.12441H0.71375C0.85017 3.6604 1.16129 4.13566 1.59795 4.47511C2.03461 4.81455 2.57192 4.99883 3.125 4.99883C3.67808 4.99883 4.21539 4.81455 4.65205 4.47511C5.08871 4.13566 5.39983 3.6604 5.53625 3.12441H18.125C18.2908 3.12441 18.4497 3.05857 18.5669 2.94136C18.6842 2.82415 18.75 2.66518 18.75 2.49942C18.75 2.33365 18.6842 2.17468 18.5669 2.05747C18.4497 1.94026 18.2908 1.87442 18.125 1.87442H5.53625C5.39983 1.33843 5.08871 0.863167 4.65205 0.523723C4.21539 0.184278 3.67808 0 3.125 0C2.57192 0 2.03461 0.184278 1.59795 0.523723C1.16129 0.863167 0.85017 1.33843 0.71375 1.87442H0.625C0.45924 1.87442 0.300268 1.94026 0.183058 2.05747C0.065848 2.17468 0 2.33365 0 2.49942C0 2.66518 0.065848 2.82415 0.183058 2.94136C0.300268 3.05857 0.45924 3.12441 0.625 3.12441ZM3.125 1.24942C3.37223 1.24942 3.6139 1.32273 3.81946 1.46008C4.02502 1.59743 4.18524 1.79265 4.27985 2.02106C4.37446 2.24947 4.39921 2.5008 4.35098 2.74328C4.30275 2.98575 4.1837 3.20848 4.00888 3.3833C3.83407 3.55811 3.61134 3.67717 3.36886 3.7254C3.12639 3.77363 2.87505 3.74887 2.64665 3.65426C2.41824 3.55965 2.22301 3.39944 2.08566 3.19388C1.94831 2.98832 1.875 2.74664 1.875 2.49942C1.875 2.16789 2.0067 1.84995 2.24112 1.61553C2.47554 1.38111 2.79348 1.24942 3.125 1.24942ZM18.125 8.12441H18.0362C17.8998 7.58842 17.5887 7.11317 17.1521 6.77372C16.7154 6.43428 16.1781 6.25 15.625 6.25C15.0719 6.25 14.5346 6.43428 14.0979 6.77372C13.6613 7.11317 13.3502 7.58842 13.2137 8.12441H0.625C0.45924 8.12441 0.300268 8.19026 0.183058 8.30747C0.065848 8.42468 0 8.58365 0 8.74941C0 8.91517 0.065848 9.07415 0.183058 9.19136C0.300268 9.30857 0.45924 9.37441 0.625 9.37441H13.2137C13.3502 9.9104 13.6613 10.3857 14.0979 10.7251C14.5346 11.0646 15.0719 11.2488 15.625 11.2488C16.1781 11.2488 16.7154 11.0646 17.1521 10.7251C17.5887 10.3857 17.8998 9.9104 18.0362 9.37441H18.125C18.2908 9.37441 18.4497 9.30857 18.5669 9.19136C18.6842 9.07415 18.75 8.91517 18.75 8.74941C18.75 8.58365 18.6842 8.42468 18.5669 8.30747C18.4497 8.19026 18.2908 8.12441 18.125 8.12441ZM15.625 9.99941C15.3778 9.99941 15.1361 9.9261 14.9305 9.78875C14.725 9.6514 14.5648 9.45618 14.4701 9.22777C14.3755 8.99936 14.3508 8.74803 14.399 8.50555C14.4472 8.26308 14.5663 8.04035 14.7411 7.86553C14.9159 7.69072 15.1387 7.57166 15.3811 7.52343C15.6236 7.4752 15.8749 7.49996 16.1034 7.59456C16.3318 7.68917 16.527 7.84939 16.6643 8.05495C16.8017 8.26051 16.875 8.50219 16.875 8.74941C16.875 9.08094 16.7433 9.39888 16.5089 9.6333C16.2745 9.86772 15.9565 9.99941 15.625 9.99941ZM18.125 14.3744H11.7862C11.6498 13.8384 11.3387 13.3632 10.9021 13.0237C10.4654 12.6843 9.92808 12.5 9.375 12.5C8.82192 12.5 8.28461 12.6843 7.84795 13.0237C7.41129 13.3632 7.10017 13.8384 6.96375 14.3744H0.625C0.45924 14.3744 0.300268 14.4403 0.183058 14.5575C0.065848 14.6747 0 14.8337 0 14.9994C0 15.1652 0.065848 15.3241 0.183058 15.4414C0.300268 15.5586 0.45924 15.6244 0.625 15.6244H6.96375C7.10017 16.1604 7.41129 16.6357 7.84795 16.9751C8.28461 17.3146 8.82192 17.4988 9.375 17.4988C9.92808 17.4988 10.4654 17.3146 10.9021 16.9751C11.3387 16.6357 11.6498 16.1604 11.7862 15.6244H18.125C18.2908 15.6244 18.4497 15.5586 18.5669 15.4414C18.6842 15.3241 18.75 15.1652 18.75 14.9994C18.75 14.8337 18.6842 14.6747 18.5669 14.5575C18.4497 14.4403 18.2908 14.3744 18.125 14.3744ZM9.375 16.2494C9.12777 16.2494 8.8861 16.1761 8.68054 16.0388C8.47497 15.9014 8.31476 15.7062 8.22015 15.4778C8.12554 15.2494 8.10079 14.998 8.14902 14.7556C8.19725 14.5131 8.3163 14.2903 8.49112 14.1155C8.66593 13.9407 8.88866 13.8217 9.13114 13.7734C9.37361 13.7252 9.62495 13.75 9.85335 13.8446C10.0818 13.9392 10.277 14.0994 10.4143 14.305C10.5517 14.5105 10.625 14.7522 10.625 14.9994C10.625 15.3309 10.4933 15.6489 10.2589 15.8833C10.0245 16.1177 9.70652 16.2494 9.375 16.2494Z"
        fill="#AB360F"
      />
    </svg>
  );
};
